// Telugu language file
export const TE = {
  preparing_zip: "జిప్ సిద్ధమవుతోంది…",
  compressing: "కుదిస్తోంది…",
  info_icon: "పూర్తిగా గుర్తించిన తర్వాత, అదనపు సభ్యులు చేరలేరు లేదా జోడించబడలేరు, మరియు అన్ని చాట్ గ్రూపులు నిష్క్రియం చేయబడతాయి. ప్రాజెక్ట్, అన్ని చాట్ గ్రూపులు మరియు డేటాతో పాటు, నిష్క్రియ స్థితిలో అందుబాటులో ఉంటుందని దయచేసి గమనించండి.",
  mark_is_done: "మీరు ప్రాజెక్ట్‌ను పూర్తిగా గుర్తించాలని నిజంగా కోరుకుంటున్నారా? గుర్తించిన తర్వాత, అదనపు సభ్యులు చేరలేరు లేదా జోడించబడలేరు, మరియు అన్ని చాట్ గ్రూపులు నిష్క్రియం చేయబడతాయి. ప్రాజెక్ట్, అన్ని చాట్ గ్రూపులు మరియు డేటాతో పాటు, నిష్క్రియ స్థితిలో అందుబాటులో ఉంటుందని దయచేసి గమనించండి.",
  mark_not_done: "మీరు ప్రాజెక్ట్‌ను మళ్లీ తెరవాలని నిజంగా కోరుకుంటున్నారా? తెరిచినట్లుగా గుర్తించిన తర్వాత, అదనపు సభ్యులు చేరవచ్చు లేదా జోడించబడవచ్చు, మరియు అన్ని చాట్ గ్రూపులు మళ్లీ సక్రియం చేయబడతాయి.",
  mark_as_completed: "ప్రాజెక్ట్‌ను పూర్తిగా గుర్తించండి",
  room_completed: "ప్రాజెక్ట్ పూర్తయింది",
  room_members: "ప్రాజెక్ట్ సభ్యులు",
  deactivated_rooms: "నిష్క్రియం చేయబడిన ప్రాజెక్టులు",
  deactivated_chats: "నిష్క్రియం చేయబడిన చాట్లు",
  completed_rooms: "పూర్తయిన ప్రాజెక్టులు",
  request_to_join_a_room: 'ప్రాజెక్ట్‌లో చేరడానికి అభ్యర్థన',
  wants_to_rejoin_room: 'Username ప్రాజెక్ట్ Roomname లో మళ్ళీ చేరాలని కోరుకుంటున్నారు.',
  invited_you_to_join_room: 'Username మిమ్మల్ని Roomname ప్రాజెక్ట్‌లో చేరడానికి ఆహ్వానించారు.',
  restart: "పునఃప్రారంభించండి",
  update_text: "కొత్త నవీకరణ అందుబాటులో ఉంది. నవీకరణను ఇన్స్టాల్ చేయడానికి పునఃప్రారంభించండి క్లిక్ చేయండి.",
  update_availble: "నవీకరణ అందుబాటులో ఉంది",
  Loading: "లోడ్ అవుతోంది...",
  logout: "లాగ్అవుట్",
  back: 'వెనక్కి',
  company_list: "కంపెనీ జాబితా",
  followers: "అనుచరులు",
  followings: "అనుసరిస్తున్నారు",
  article: "వ్యాసం",
  companies: "కంపెనీలు",
  one_to_one_chat: " ఒకరికి ఒకరు చాట్",
  profile: "ప్రొఫైల్",
  company: "కంపెనీ",
  company_selection: "కంపెనీ ఎంపిక",
  home: "హోమ్",
  contact: "సంప్రదించండి ",
  add_company: "కంపెనీ జోడించండి ",
  add_project: "ప్రాజెక్ట్ జోడించండి ",
  capacities: "సామర్థ్యాలు ",
  work_area: "పని ప్రాంతం",
  company_services: "కంపెనీ సేవలు",
  website: "వెబ్సైట్",
  search_contacts: "సంప్రదింపులను శోధించండి",
  add_or_join_a_company: "కంపెనీ జోడించండి లేదా చేరండి",
  follow: "అనుసరించండి",
  following: "అనుసరిస్తోంది",
  like: "ఇష్టం",
  company_contacts: "కంపెనీ సంప్రదింపు",
  leave_the_company: "కంపెనీని వదిలివెళ్లండి",
  news: "వార్తలు",
  earlier: "ముందు",
  action: "చర్య",
  another_action: "మరొక చర్య",
  something_else: "వేరేది",
  search: "శోధించండి",
  search_rooms: "ప్రాజెక్టులను శోధించండి",
  search_articles: "వ్యాసాలను శోధించండి",
  contacts: "సంప్రదింపులు",
  suggestions: "సూచనలు",
  project_list: "ప్రాజెక్ట్ జాబితా",
  search_results: "శోధన ఫలితాలు",
  add_or_join_project: "ప్రాజెక్ట్ జోడించండి లేదా చేరండి",
  details: "వివరాలు",
  your_position_within_company: "దయచేసి కంపెనీలో మీ స్థానాన్ని ఎంచుకోండి.",
  close_modal: "మూసివేయండి",
  map: "నక్షా",
  or: "లేదా",
  name: "పేరు*",
  street: "వీధి*",
  house_number: "ఇంటి సంఖ్య",
  postal_code: "పోస్టల్ కోడ్",
  city: "నగరం*",
  opened_by: "దీని ద్వారా తెరవబడింది:",
  project_No: "ప్రాజెక్ట్-సంఖ్య: ",
  building_type: "భవన రకం*",
  building_types: "భవన రకం",
  add_join: "జోడించండి/చేరండి",
  mandatory_fiels: "*తప్పనిసరి ఫీల్డ్లు",
  invalid_fiels: "ఈ ఫీల్డ్ అవసరం",
  add_or_join_company: "కంపెనీ జోడించండి లేదా చేరండి",
  name_of_the_company: "కంపెనీ పేరు",
  edit_company_details: "కంపెనీ వివరాలను సవరించండి",
  branch_of_the_building_industry: "నిర్మాణ పరిశ్రమ శాఖ",
  corporate_form: "కార్పొరేట్ రూపం",
  position_within_company: "కంపెనీలో స్థానం",
  request_confirmation: "పెండింగ్ ప్రాజెక్ట్ అభ్యర్థనలు",
  company_e_mail: "కంపెనీ ఇ-మెయిల్",
  type_of_filter: "ఫిల్టర్ చేయడానికి టైప్ చేయండి...",
  setting: "సెట్టింగ్",
  dashboard: "డాష్బోర్డ్",
  settings: "సెట్టింగ్లు",
  views: "వీక్షణలు",
  times_seen: "సార్లు చూసారు",
  see_more: "...మరిన్ని",
  see_less: "...తక్కువ",
  show_more: "మరిన్ని చూపించు",
  show_less: "తక్కువ చూపించు",
  in_search: "శోధనలో",
  reset_password: "పాస్వర్డ్ రీసెట్ చేయండి",
  submit: "సమర్పించండి",
  password: "పాస్వర్డ్",
  email: "ఇమెయిల్",
  confirm_password: "పాస్వర్డ్ నిర్ధారించండి",
  reset_email: "ఇ-మెయిల్ రీసెట్ చేయండి",
  update: "నవీకరించండి",
  new_email: "కొత్త ఇ-మెయిల్",
  kjuup_message: "Kjuup సందేశం",
  delete_profile: "ప్రొఫైల్‌ను తొలగించాలా?",
  my_position: "నా స్థానం:",
  add: "జోడించండి",
  owner_company_admin: "కంపెనీ అడ్మిన్ :",
  owner_company_admin_new: "కంపెనీ అడ్మిన్",
  mutual_contact: "పరస్పర సంప్రదింపు",
  mutual_contacts: "పరస్పర సంప్రదింపులు",
  co_owner: "సహ-యజమాని",
  managing_director: "నిర్వహణ డైరెక్టర్",
  associate: "అసోసియేట్",
  secretary: "సెక్రటరీ",
  employee: "ఉద్యోగి",
  project_manage: "ప్రాజెక్ట్ మేనేజర్",
  auto_chat_translation: "ఆటో చాట్ అనువాదం",
  translate_room_group_names: "చాట్ గ్రూప్ పేర్లను అనువదించండి",
  translate_room_group_names_info: "ప్రారంభించినప్పుడు, చాట్ గ్రూప్ పేర్లు ఇంటర్‌ఫేస్ భాషలోకి స్వయంచాలకంగా అనువదించబడతాయి.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "ఎనేబుల్ చేసినప్పుడు, యాప్ తెరిచేటప్పుడు మెసేజ్‌ల బదులుగా ఇ-మెయిల్ ట్యాబ్ డిఫాల్ట్‌గా తెరవబడుతుంది.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "భాష",
  english: "ఆంగ్లం",
  german: "జర్మన్",
  french: "ఫ్రెంచ్",
  italian: "ఇటాలియన్",
  change_language: "భాష మార్చండి",
  my_companies: "నా కంపెనీలు",
  employees: "ఉద్యోగులు",
  invite_with_a: "Kjuupకు ఆహ్వానించండి",
  add_member: "సభ్యుడిని జోడించండి",
  add_user: "వినియోగదారుని జోడించండి",
  send_location: "స్థానాన్ని పంపండి",
  assign_admin_rights: "అడ్మిన్ హక్కును సర్దుబాటు చేయండి",
  deactivate_company: "కంపెనీని నిష్క్రియం చేయండి",
  remove_employees: "ఉద్యోగులను తొలగించండి",
  remove_members: "సభ్యులను తొలగించండి",
  no_user_found: "వినియోగదారు కనుగొనబడలేదు!",
  approve: "ఆమోదించండి!",
  deselect_all: "అన్నింటినీ ఎంపిక రద్దు చేయండి",
  select_all: "అన్నీ ఎంచుకోండి",
  translation_on_building_projects: "ప్రాజెక్టులలో అనువాదం",
  reported_capacities: "నివేదించిన సేవలు",
  up_to_50m_exact: "50 మీ వరకు ఖచ్చితమైన",
  company_details_service: "కంపెనీ సేవలు",
  company_contact: "కంపెనీ సంప్రదింపు",
  invite_with_link: "Kjuupకు ఆహ్వానించండి",
  share_link: "లింక్ భాగస్వామ్యం చేయండి",
  share_company_link: "లింక్ భాగస్వామ్యం చేయండి",
  qr_code: "QR కోడ్",
  copy_link: "లింక్ కాపీ చేయండి",
  cancel_link: "లింక్ రద్దు చేయండి",
  who_has_confirmed_services: "మీ సేవలను ఎవరు నిర్ధారించారు?",
  projectss: "ప్రాజెక్టులు",
  add_services: "సేవలను జోడించండి",
  services: "సేవలు",
  save_text: "సేవ్ చేయండి",
  share_on: "భాగస్వామ్యం చేయండి:",
  articlen: "వ్యాసం",
  invite_user_to_confirm_service: "కంపెనీకి సేవలను నిర్ధారించడానికి వినియోగదారులను ఆహ్వానించండి.",
  link_copied: "లింక్ కాపీ చేయబడింది!",
  email_copied: "ఇమెయిల్ కాపీ చేయబడింది!",
  personal_article: "వ్యక్తిగత వ్యాసం",
  company_article: "కంపెనీ వ్యాసం",
  characters_remaining: "మిగిలిన అక్షరాలు",
  optional_information: "ఐచ్ఛిక సమాచారం",
  project: "ప్రాజెక్ట్",
  projects: "ప్రాజెక్టులు...",
  abort: "విస్మరించండి",
  preview: "ప్రివ్యూ",
  post: "పోస్ట్ చేయండి",
  of: "యొక్క",
  remove: "తొలగించండి",
  free_capacity: "ఉద్యోగ పోర్టల్",
  current_status_overview: "ప్రస్తుత స్థితి అవలోకనం",
  report_capacities: "సేవలను నివేదించండి",
  report_text: "నివేదిక",
  search_capacities: "కాంట్రాక్టర్లను కనుగొనండి",
  add_project_user: "ప్రాజెక్ట్ వినియోగదారుని జోడించండి",
  media: "మీడియా",
  links: "లింకులు",
  docs: "డాక్యుమెంట్లు",
  featured_products: "విశేష ఉత్పత్తులు...",
  title: "శీర్షిక",
  text: "టెక్స్ట్",
  feed_details: "ఫీడ్ వివరాలు",
  add_employee: "ఉద్యోగిని జోడించండి",
  latest: "తాజా",
  my_projects: "నా ప్రాజెక్టులు",
  cancel: "రద్దు చేయండి",
  continue: "కొనసాగించండి",
  role_in_the_building_industry: "నిర్మాణ పరిశ్రమలో పాత్ర",
  als: "గా",
  join: "చేరండి",
  find: "కనుగొనండి",
  request_to_join_a_company: "కంపెనీలో చేరడానికి అభ్యర్థన",
  wants_to_join_the_company: "కంపెనీలో చేరాలనుకుంటుంది",
  filter_by: "ద్వారా ఫిల్టర్ చేయండి",
  ok: "సరే",
  close: "మూసివేయండి",
  weekly_statistics: "వారాంతర గణాంకాలు",
  is_following_you: "మిమ్మల్ని అనుసరిస్తోంది.",
  as: "గా",
  has_joined_the: "కంపెనీలో చేరింది",
  has_looked_at_your_profile: "మీ ప్రొఫైల్‌ను చూసింది.",
  time: "సమయం",
  in_searches_in_past_week: "గత వారంలో శోధనలలో.",
  has_liked_your_article: "మీ వ్యాసాన్ని ఇష్టపడింది.",
  has_published_a_new_article: "కొత్త వ్యాసాన్ని ప్రచురించింది.",
  you: "మీరు",
  all_views: "అన్ని వీక్షణలు",
  all_profile_views: "అన్ని ప్రొఫైల్ వీక్షణలు",
  mutual_company: "పరస్పర కంపెనీ",
  artical_text: "వ్యాసం రాయండి...",
  you_have_appeared: "మీరు కనిపించారు",
  your_request_at_the_company: "కంపెనీలో మీ అభ్యర్థన",
  times_you_have_appeared_in_searches: "సార్లు మీరు శోధనలలో కనిపించారు",
  appear_more_often_in_searches: "శోధనలలో తరచుగా కనిపించండి",
  you_have_been_found: "మిమ్మల్ని కనుగొన్నారు",
  improve_profile: "ప్రొఫైల్‌ను మెరుగుపరచండి",
  choose_existing_contact_for_single_chat: "ఒకే చాట్ కోసం ఇప్పటికే ఉన్న సంప్రదింపును ఎంచుకోండి:",
  in_order_to_add_new_contacts: "కొత్త సంప్రదింపులను జోడించడానికి, దయచేసి ప్రొఫైల్ పేజీలో కొత్త సంప్రదింపులను శోధించండి.",
  times_in_searches_in_the_last_week: "గత వారంలో శోధనలలో సార్లు. మీ ప్రొఫైల్‌ను నవీకరించండి మరియు సులభంగా కనుగొనడానికి మరిన్ని వివరాలను జోడించండి.",
  has_been_confirmed: "నిర్ధారించబడింది.",
  have_joined_the: "చేరారు ",
  building_project: " నిర్మాణ ప్రాజెక్ట్.",
  select_with_which_company_you_want_to_connect_to_the_project: "మీరు ప్రతినిధీకరించే కంపెనీని ఎంచుకోండి. ఇది ఇతర పాల్గొనేవారికి ప్రదర్శించబడుతుంది.",
  select_with_which_company_you_want_to_connect_to_the_chat: "మీరు ప్రతినిధీకరించే కంపెనీని ఎంచుకోండి. ఇది ఇతర పాల్గొనేవారికి ప్రదర్శించబడుతుంది.",
  select_internal_section: "దయచేసి అంతర్గత విభాగాన్ని ఎంచుకోండి",
  select_profile_image: "ప్రొఫైల్ చిత్రాన్ని ఎంచుకోండి",
  share_user: "వినియోగదారుని భాగస్వామ్యం చేయండి",
  contact_sender_message:
    "Share this link to invite a non-member of Kjuup to Kjuup. This link can be used by multiple people to register.",
  project_sender_message:
    "Share this link to invite a non-member of Kjuup to the project project name. This link can be used by multiple people to register and join the project project name in Kjuup.",
  company_sender_message:
    "Share this link to invite a non-member of Kjuup to the company company name. This link can be used by multiple people to register and join the company in Kjuup.",
  contact_receivers_message:
    "Invitation link to join Kjuup. Please click the link to register for kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "In case you are installing Kjuup via Apple App Store, you must click this link after successful download, to be able to register.",
  project_receivers_message:
    "Invitation link to join the project project name in Kjuup. Please click the link to register for Kjuup and to join the project project name.",
  company_receivers_message:
    "Invitation link to the company company name in Kjuup. Please click on the link to register for Kjuup and to join the company company name.",
  sign_in: "సైన్ ఇన్",
  enter_your_email_add: "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
  forgot_password: "పాస్వర్డ్ మర్చిపోయారా",
  dont_have_account: "ఖాతా లేదా?",
  register: "నమోదు చేయండి",
  get_app: "అనువర్తనాన్ని పొందండి",
  registration: "నమోదు",
  dep_ing: "Dipl.-Ing.",
  dr: "డాక్టర్",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "ప్రొఫెసర్",
  first_name: "మొదటి పేరు",
  last_name: "చివరి పేరు",
  have_an_account: "ఖాతా ఉందా?",
  when_register_you_agree: "నమోదు చేస్తున్నప్పుడు మీరు మా",
  term_of_use: "వినియోగ నిబంధనలకు",
  to: "అంగీకరిస్తారు.",
  in_our: "మా",
  data_policy: "డేటా విధానాలలో",
  they_find_out: "వారు తెలుసుకుంటారు,",
  we_provide_store_data: "మేము సమాచారాన్ని ఎలా సేకరిస్తాము, ప్రాసెస్ చేస్తాము మరియు నిల్వ చేస్తాము.",
  leaving_company_text: "మీరు నిజంగా కంపెనీని వదిలివెళ్లాలనుకుంటున్నారా? కంపెనీని వదిలివెళ్లినప్పుడు మీరు అన్ని సంబంధిత ప్రాజెక్టులు మరియు చాట్ గ్రూపులను కూడా వదిలివెళ్లుతారు. మీరు ఎప్పుడైనా మరొక కంపెనీతో ఈ ప్రాజెక్టులలో మళ్లీ చేరవచ్చు.",
  delete_profile_text: "మీరు నిజంగా మీ ప్రొఫైల్‌ను తొలగించాలనుకుంటున్నారా? మీరు మీ ప్రొఫైల్‌ను తొలగించినప్పుడు కంపెనీలు, ప్రాజెక్టులు మరియు చాట్లకు అన్ని కనెక్షన్లు తొలగించబడతాయి. మీరు ఎప్పుడైనా కొత్త ప్రొఫైల్‌ను సృష్టించవచ్చు.",
  confirm: "నిర్ధారించండి",
  reject: "తిరస్కరించండి",
  requet_to_leave: "వదిలివెళ్లడానికి అభ్యర్థన",
  choose: "ఎంచుకోండి",
  your_add_member: "సభ్యుడిని జోడించండి",
  if_you: "మీరు అయితే",
  can_not_find: "ఇక్కడ మీ సంప్రదింపును కనుగొనలేరు.",
  please_wait: "దయచేసి వేచి ఉండండి..",
  imprint_gtc: "ఇంప్రింట్/GTC",
  register_confirm_popup: "లాగిన్ అయ్యే ముందు మీ Kjuup ఇమెయిల్‌ను ధృవీకరించండి. మేము నిర్ధారణ లింక్ పంపాము. కనిపించకపోతే స్పామ్ ఫోల్డర్ కూడా చూడండి.",
  PENDING_GROUP_USER:
    "will receive messages only after invitation to the project has been confirmed. An additional message will appear once the invitation to the project has been confirmed.",
  PENDING: "ప్రాజెక్ట్‌కు ఆహ్వానం నిర్ధారణ పెండింగ్‌లో ఉంది",
  denied_group_chat: " ప్రాజెక్ట్ ఆహ్వానాన్ని తిరస్కరించి ఈ గ్రూప్‌ను వదిలివెళ్లింది.",
  joined_group_chat: " ఈ గ్రూప్‌లో చేరింది",
  you_joined_group_chat: "మీరు ఈ గ్రూప్‌లో చేరారు.",
  Others: "ఇతరులు",
  LEFT_GROUP: "ఈ చాట్ గ్రూప్‌ను వదిలివెళ్లింది.",
  YOU_LEFT_GROUP: "ఈ చాట్ గ్రూప్‌ను వదిలివెళ్లారు.",
  days: "రోజులు",
  day: "రోజు",
  hour: "గంట",
  hide_project: "ప్రాజెక్ట్‌ను దాచండి",
  hide_project_popup_text: "మీరు ప్రాజెక్టులను దాచితే, అవి Kjuupలో కనుగొనబడవు. ప్రాజెక్ట్ సభ్యులు మాత్రమే కొత్త వినియోగదారులను ప్రాజెక్ట్‌కు ఆహ్వానించవచ్చు.",
  branch: "శాఖ",
  photo_video_media_lib: "ఫోటో - వీడియో మీడియా లైబ్రరీ",
  document: "డాక్యుమెంట్",
  location_meeting: "స్థానం / సమావేశం",
  all_member_of_project: "ప్రాజెక్ట్ యొక్క అన్ని సభ్యులు",
  pending_request: "పెండింగ్ ప్రాజెక్ట్ అభ్యర్థనలు",
  no_pending_request: "పెండింగ్ అభ్యర్థనలు కనుగొనబడలేదు!",
  news_feed: "న్యూస్-ఫీడ్",
  user_info: "గ్రూప్ సమాచారం",
  leave_project: "ప్రాజెక్ట్‌ను వదిలివెళ్లండి",
  media_link_docs: "ఫైళ్లు",
  search_chat: "చాట్ శోధించండి",
  export_chat_group: "గత నెల నుండి చాట్ గ్రూప్ డేటాను ఎగుమతి చేయండి",
  request_complete_chat_history: "పూర్తి చాట్ చరిత్రను అభ్యర్థించండి",
  leave_chat_group: "చాట్ గ్రూప్‌ను వదిలివెళ్లండి",
  add_user_project: "వినియోగదారుని జోడించండి",
  me: "నేను",
  max_open_one_to_one: "ప్రస్తుతం గరిష్టంగా. 2 ఒకరికి ఒకరు చాట్లు దిగువ మరియు ఎగువ విభాగంలో సమాంతరంగా తెరవబడతాయి. మొత్తంగా గరిష్టంగా. 4 ఒకరికి ఒకరు చాట్లు సాధ్యమే.",
  are_you_sure_you_want_leave_chat: "మీరు నిజంగా ఈ చాట్ గ్రూప్‌ను వదిలివెళ్లాలనుకుంటున్నారా?",
  create_group: "గ్రూప్ సృష్టించండి",
  adding_members: "సభ్యులను జోడిస్తోంది...",
  creating_the_chat: "చాట్ సృష్టిస్తోంది...",
  finishing_setup: "సెటప్ పూర్తి చేస్తోంది...",
  group_name: "గ్రూప్ పేరు",
  by: "ద్వారా:",
  mandetory: "*తప్పనిసరి",
  delteed: "తన/ఆమె ప్రొఫైల్‌ను తొలగించి గ్రూప్ చాట్‌ను వదిలివెళ్లింది.",
  deleted_direct: "తన/ఆమె ప్రొఫైల్‌ను తొలగించి చాట్‌ను వదిలివెళ్లింది.",
  unhidden_message: "మీరు ప్రాజెక్టులను దాచకుండా ఉంచితే, Kjuup యొక్క అన్ని సభ్యులచే వాటిని కనుగొనవచ్చు.",
  account_deleted: "ఖాతా తొలగించబడింది.",
  refuse_company: "మీరు నిజంగా కంపెనీ ఆహ్వానాన్ని తిరస్కరించాలనుకుంటున్నారా?",
  follow_additional: "అదనపు వినియోగదారులను అనుసరించండి",
  f_add: "నేరుగా సందేశాలకు వాటిని అందుబాటులో ఉంచడానికి Kjuup యొక్క అదనపు వినియోగదారులను అనుసరించండి.",
  c_inv: "కంపెనీ ఆహ్వానం(లు)",
  invited_o_Company: "మీరు కంపెనీలో చేరడానికి ఆహ్వానించబడ్డారు",
  refuse_companyX: "మీరు నిజంగా కంపెనీ అభ్యర్థనను తిరస్కరించాలనుకుంటున్నారా?",
  a_Da: "ఖాతా నిష్క్రియం చేయబడింది.",
  has_deactivated: "తన/ఆమె ప్రొఫైల్‌ను నిష్క్రియం చేసింది.",
  reactive: "తన/ఆమె ప్రొఫైల్‌ను మళ్లీ సక్రియం చేసింది.",
  juup_note: "*వినియోగదారు పేరుతో నమోదు Kjuup+ సభ్యులకు మాత్రమే అందుబాటులో ఉంది",
  username: "వినియోగదారు పేరు*",
  email_username: "ఇమెయిల్/వినియోగదారు పేరు*",
  sPinText: "దయచేసి 6-అంకెల భద్రత PIN అందించండి. మీరు మీ పాస్వర్డ్‌ను మరచిపోతే ఈ PIN అవసరం మరియు మీ ఖాతాను నిర్ధారించడానికి తప్పనిసరి.",
  DeleteKjuupPlusText: "మీరు నిజంగా మీ ప్రొఫైల్‌ను తొలగించాలనుకుంటున్నారా? మీరు మీ ప్రొఫైల్‌ను తొలగించినప్పుడు కంపెనీలు, ప్రాజెక్టులు మరియు చాట్లకు అన్ని కనెక్షన్లు తొలగించబడతాయి.\n\nఖాతా తొలగింపు తర్వాత 48 గంటలలో మీరు వినియోగదారు పేరు, పాస్వర్డ్ మరియు PINతో సైన్ ఇన్ చేయడం ద్వారా మీ ఖాతాను మళ్లీ సక్రియం చేయవచ్చు.",
  reactive_text: "మీ ఖాతా తొలగించబడింది. మీ ఖాతాను మళ్లీ సక్రియం చేయడానికి దయచేసి మళ్లీ సక్రియం చేయండి క్లిక్ చేయండి.",
  rac: "మళ్లీ సక్రియం చేయండి",
  ac_ss: "ఖాతా విజయవంతంగా మళ్లీ సక్రియం చేయబడింది.",
  not_valid_pin: "PIN చెల్లదు",
  only_for_kjuup: "*వినియోగదారు పేరు మరియు PIN ద్వారా పాస్వర్డ్ రీసెట్ Kjuup+ సభ్యులకు మాత్రమే అందుబాటులో ఉంది.",
  resetPIN: "PIN రీసెట్ చేయండి",
  enter_current_pin: "దయచేసి మీ ప్రస్తుత PIN నమోదు చేయండి",
  enter_new: "కొత్త PIN నమోదు చేయండి",
  pin_to_confirm: "దయచేసి నిర్ధారించడానికి PIN అందించండి.",
  change_username: "వినియోగదారు పేరును రీసెట్ చేయండి",
  pp_not_match: "పాస్వర్డ్ - మరియు నిర్ధారణ పాస్వర్డ్ సరిపోలడం లేదు",
  reactive_itself: "మీరు మీ ప్రొఫైల్‌ను మళ్లీ సక్రియం చేసారు.",
  has_deactivated_itself: "మీరు మీ ప్రొఫైల్‌ను నిష్క్రియం చేసారు.",
  more_than_two: "ప్రస్తుతం నేరుగా సందేశాలు 2 వినియోగదారులతో మాత్రమే సమాంతరంగా చేయవచ్చు.",
  Chats: "నేరుగా సందేశాలు",
  only_in_mobileL: "స్వదేశీ వీడియోలు ప్రస్తుతం మొబైల్ అనువర్తనం ద్వారా మాత్రమే అప్‌లోడ్ మరియు పోస్ట్ చేయవచ్చు. దయచేసి Youtube మరియు Vimeo యొక్క వీడియో లింక్‌లను ఉపయోగించండి.",
  register_pin_text: "దయచేసి మీ వ్యక్తిగత 6-అంకెల PIN ఎంచుకోండి. ఖాతా రీసెట్ కార్యకలాపాలను ప్రారంభించడానికి ఈ PIN అవసరం.",
  internal_project: "అంతర్గత",
  external_projects: "బాహ్య",
  in_deacticted: "అంతర్గత విభాగం నిష్క్రియం చేయబడింది.",
  create_article: "వ్యాసం సృష్టించండి",
  new_article_selection: "బాహ్య న్యూస్-ఫీడ్ కోసం వ్యాసం సృష్టించండి",
  new_article_selection_internal: "ఇన్-హౌస్ వ్యాసం సృష్టించండి",
  active_trans_title: "స్వయంచాలక అనువాదాన్ని ఆన్ చేయాలా?",
  active_trans: "ఆన్ చేసినప్పుడు, అన్ని వచ్చే చాట్ సందేశాలు మీరు ఎంచుకున్న యాప్ భాషలో అనువదించబడతాయి.",
  disable_trans: "మీరు నిజంగా స్వయంచాలక అనువాదాన్ని నిష్క్రియం చేయాలనుకుంటున్నారా?",
  allow_access_chat: "పూర్తి చాట్ చరిత్రను చూపించండి",
  toggle_chat_history_on: "మీరు నిజంగా వినియోగదారు పూర్తి చాట్ చరిత్రను చూడాలనుకుంటున్నారా?",
  toggle_chat_history_off: "మీరు నిజంగా వినియోగదారు చాట్‌లో చేరిన పాయింట్ నుండి చాట్ చరిత్రను మాత్రమే చూడాలనుకుంటున్నారా?",
  check_selected_settings: "దయచేసి ఎంచుకున్న అన్ని వినియోగదారులకు చాట్ చరిత్ర సెట్టింగ్‌లను తనిఖీ చేయండి!",
  chat_from_start_have: "మీరు ఈ గ్రూప్‌లో చేరారు. చాట్ చరిత్ర భాగస్వామ్యం చేయబడింది.",
  chat_from_start_has: "ఈ గ్రూప్‌లో చేరింది. చాట్ చరిత్ర భాగస్వామ్యం చేయబడింది.",
  Address: "చిరునామా",
  read_by: "ద్వారా చదవబడింది",
  deliver_to: "పంపబడింది",
  remaining: "మిగిలిన",
  message_info: "సందేశ సమాచారం",
  request_to_join_only: "చేరడానికి అభ్యర్థన",
  unfollow: "అనుసరించడం ఆపండి",
  company_username: "వినియోగదారు పేరు",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "నా అడ్మిన్ హక్కులను తొలగించండి",
  makeEmp: "మీరు నిజంగా వినియోగదారు నుండి కంపెనీ అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  remove_my_self: "మీరు నిజంగా మీ ఖాతా నుండి కంపెనీ అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  makeAdmin: "మీరు నిజంగా వినియోగదారుకు కంపెనీ అడ్మిన్ హక్కులను ఇవ్వాలనుకుంటున్నారా?",
  remove_member: "సభ్యుడిని తొలగించండి",
  remove_following_confirm: "మీరు నిజంగా {name} ను ఫాలో చేసే జాబితా నుండి తొలగించాలనుకుంటున్నారా?",
  remove_follower_confirm: "మీరు నిజంగా {name} ను మీ ఫాలోయర్ల జాబితా నుండి తొలగించాలనుకుంటున్నారా? తొలగిస్తే అతనికి/ఆమెకు తెలియజేయబడదు.",
  do_you_really_want_to_remove: "మీరు నిజంగా కంపెనీ నుండి వినియోగదారు పేరును తొలగించాలనుకుంటున్నారా?",
  invite_all: "కంపెనీ యొక్క అన్ని సభ్యులను ఆహ్వానించండి",
  invite_all_members: "అన్ని సభ్యులను ఆహ్వానించండి",
  mems: "అన్ని ఇతర సభ్యులు",
  dep_loc: "విభాగం/స్థానం/టీమ్",
  depAdmin: "విభాగ అడ్మిన్",
  add_remove_admin: "కంపెనీ అడ్మిన్ స్థానాన్ని జోడించండి/తొలగించండి",
  add_remove_dep_admin: "విభాగ అడ్మిన్ స్థానాన్ని జోడించండి/తొలగించండి",
  remove_employees_dept: "నుండి ఉద్యోగులను తొలగించండి",
  want_to_join_dep: "వినియోగదారు పేరు కంపెనీ companyname యొక్క విభాగం/స్థానం/టీమ్ depnameలో చేరాలనుకుంటుంది.",
  you_invited: "మీరు కంపెనీ companyname యొక్క విభాగం/స్థానం/టీమ్ depnameలో చేరడానికి ఆహ్వానించబడ్డారు.",
  dep_remove: "మీరు నిజంగా వినియోగదారు నుండి విభాగం లేదా స్థానానికి అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  add_dep: "మీరు నిజంగా వినియోగదారుకు విభాగం లేదా స్థానానికి అడ్మిన్ హక్కులను ఇవ్వాలనుకుంటున్నారా?",
  my_self_dep_remove: "మీరు నిజంగా మీ ఖాతా నుండి విభాగ అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  member: "సభ్యుడు",
  admin: "అడ్మిన్",
  remove_project_admin: "మీరు నిజంగా ప్రాజెక్ట్ నుండి సభ్యుడిని తొలగించాలనుకుంటున్నారా?",
  remove_my_self_project: "మీరు నిజంగా అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  remove_member_admin_right: "మీరు నిజంగా వినియోగదారు నుండి అడ్మిన్ హక్కులను తొలగించాలనుకుంటున్నారా?",
  add_member_admin_right: "మీరు నిజంగా వినియోగదారుకు అడ్మిన్ హక్కులను జోడించాలనుకుంటున్నారా?",
  add_remove_Poss: "అడ్మిన్ స్థానాన్ని జోడించండి/తొలగించండి",
  forward: "ముందుకు పంపండి",
  edit: "సవరించండి",
  only_kjuup_plus_can: "Kjuup+ కంపెనీలు మాత్రమే వ్యాసాలను పోస్ట్ చేయవచ్చు.",
  add_images: "చిత్రం(లు) జోడించండి",
  request_confirmation: 'పెండింగ్ ప్రాజెక్ట్ ఆహ్వానాలు',
  Activity: "కార్యాచరణ",
  latest_messages: "తాజా సందేశాలు",
  hours: "గంటలు",
  minute: "నిమిషాలు",
  seconds: "సెకన్లు",
  days: "రోజులు",
  yesterday: "నిన్న",
  last_week: "గత వారం",
  next_week: "తర్వాతి వారం",
  Last_month: "గత నెల",
  All: "అన్నీ",
  register_plus: "నమోదు ప్లస్",
  select_files: "ఫైళ్లను ఎంచుకోండి",
  monthsFullName: ["జనవరి", "ఫిబ్రవరి", "మార్చి", "ఏప్రిల్", "మే", "జూన్", "జూలై", "ఆగస్ట్", "సెప్టెంబర్", "అక్టోబర్", "నవంబర్", "డిసెంబర్"],
  company_deploc_receivers_message: "Kjuupలో కంపెనీ company name యొక్క విభాగానికి ఆహ్వాన లింక్. దయచేసి Kjuupకు నమోదు చేయడానికి మరియు కంపెనీ company nameలో చేరడానికి లింక్‌ను క్లిక్ చేయండి.",
  no_news: "వార్తలు అందుబాటులో లేవు",
  reminder: "రిమైండర్",
  np_reminder: "ToDo-లు లేవు",
  move_to_reminder: "ToDo-కు తరలించండి",
  remove_reminder: "మీరు నిజంగా ఈ సందేశాన్ని మీ ToDo-ల జాబితా నుండి తీసివేయాలనుకుంటున్నారా?",
  remove_all_reminder: "అన్ని ToDo-లను తీసివేయండి",
  remove_all_confirm: "మీరు నిజంగా అన్ని సందేశాలను మీ ToDo-ల జాబితా నుండి తీసివేయాలనుకుంటున్నారా?",
  remove_from_reminder: "రిమైండర్ నుండి తీసివేయండి",
  prevent_email: "ఇ-మెయిల్‌ను వినియోగదారు పేరుగా ఉపయోగించలేరు.",
  allow_noti: "దయచేసి నోటిఫికేషన్‌లను అనుమతించండి.",
  join_cap: "చేరండి",
  pass_minimum: "**పాస్వర్డ్‌కు చిన్న-, పెద్ద అక్షరం, సంఖ్య మరియు ప్రత్యేక అక్షరం సహా 12 అక్షరాలు అవసరం.",
  pass_error: "దయచేసి పాస్వర్డ్ అవసరాలను తనిఖీ చేయండి",
  people_that_like_article: "వ్యాసాన్ని ఇష్టపడే వ్యక్తులు.",
  people_who_like_article: "మీ వ్యాసాన్ని ఇష్టపడే వ్యక్తులు.",
  message_delete: "ఈ సందేశం తొలగించబడింది.",
  message_edited: "సవరించబడింది",
  edit_message: "సందేశాన్ని సవరించు",
  edit_window_expired: "సందేశాలను పంపిన 10 నిమిషాలలోపు మాత్రమే సవరించవచ్చు.",
  message_edit_save: "సేవ్",
  copy: "కాపీ",
  bookmark: "బుక్‌మార్క్",
  add_reaction: "రియాక్షన్ జోడించు",
  delete_message: "సందేశాన్ని తొలగించు",
  more_options: "మరిన్ని ఎంపికలు",
  info: "సమాచారం",
  link_invite: "లింక్ ద్వారా ఆహ్వానించండి",
  ll_nkk: "Kjuupకు ఆహ్వానించండి",
  selected: "ఎంచుకున్నది",
  is_active: "సక్రియం",
  inactive: "నిష్క్రియం",
  last_online: "చివరిగా ఆన్‌లైన్ {{when}}",
  remove_user_l: "తీసివేయండి",
  link_expire: "ప్రతి రూపొందించిన లింక్ 72 గంటలు చెల్లుబాటు అవుతుంది.",
  company_language: "కంపెనీ భాష",
  company_language_info: "భాష ఎంపిక కంపెనీకి సంబంధించిన అన్ని ఇమెయిల్ నిర్ధారణలకు ఉపయోగించబడుతుంది.",
  s_image: "చిత్రం",
  m_image: "చిత్రాలు",
  removeMsg: "తీసివేయడానికి టాప్ చేయండి",
  block: 'బ్లాక్ చేయండి',
  unblock: 'అన్‌బ్లాక్ చేయండి',
  blocks: 'మీరు నిజంగా ఈ వినియోగదారుని బ్లాక్ చేయాలనుకుంటున్నారా?',
  unblocks: 'మీరు నిజంగా ఈ వినియోగదారుని అన్‌బ్లాక్ చేయాలనుకుంటున్నారా?',
  bolcked_click_un_block: 'మీరు ఈ సంప్రదింపును బ్లాక్ చేసారు. బ్లాకింగ్‌ను తీసివేయడానికి ఇక్కడ క్లిక్ చేయండి.',
  you_have_unblocked: 'మీరు ఈ సంప్రదింపును అన్‌బ్లాక్ చేసారు.',
  you_have_blocked: 'మీరు ఈ సంప్రదింపును బ్లాక్ చేసారు.',
  unblock_to_send: 'సందేశం పంపడానికి వినియోగదారుని అన్‌బ్లాక్ చేయండి.',
  pilot_text: "నిర్మాణ అంశాలకు ప్రత్యేక AI",
  startup_screen_label: "ప్రారంభ స్క్రీన్",
  startup_screen_info: "Kjuup ప్రారంభమైనప్పుడు ఏ స్క్రీన్ తెరవాలో ఎంచుకోండి.",
  startup_screen_feed: "Home",
  startup_screen_messages: "సందేశాలు",
  startup_screen_saved: "ప్రారంభ స్క్రీన్ నవీకరించబడింది",
email_on: "ఇమెయిల్ నోటిఫికేషన్ చాట్లు",
  email_on_grp: "ఇమెయిల్ నోటిఫికేషన్",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "ఈ ప్రాజెక్ట్‌కు ఇమెయిల్ నోటిఫికేషన్‌లను సక్రియం లేదా నిష్క్రియం చేయండి. ఈ ఎంపిక వ్యక్తిగత సెట్టింగ్‌ల ద్వారా \"ఇమెయిల్ నోటిఫికేషన్ చాట్లు\" సక్రియం చేయబడినప్పుడు మాత్రమే అందుబాటులో ఉంటుంది.",
  todo_notification_info: "మీకు కొత్త పని కేటాయించబడిన ప్రతిసారీ మీకు తెలియజేయబడుతుంది.",
  info_val: "కొత్త చాట్ సందేశం తక్కువ సమయంలో చదవకపోతే మీకు ఇమెయిల్ వస్తుంది. దీన్ని నిర్దిష్ట ప్రాజెక్టులు లేదా చాట్‌ల కోసం వాటి సెట్టింగ్‌లలో లేదా చాట్ గ్రూప్ సమాచారంలో ఆఫ్ చేయవచ్చు.",
  email_groups: "ఈ చాట్‌కు ఇమెయిల్ నోటిఫికేషన్‌లను సక్రియం లేదా నిష్క్రియం చేయండి. ఈ ఎంపిక వ్యక్తిగత మరియు ప్రాజెక్ట్ సెట్టింగ్‌ల ద్వారా \"ఇమెయిల్ నోటిఫికేషన్ చాట్లు\" సక్రియం చేయబడినప్పుడు మాత్రమే అందుబాటులో ఉంటుంది.",
  add_update_email: "ఇమెయిల్ జోడించండి/నవీకరించండి",
  text_to_verifiy: "\"ఇమెయిల్ నోటిఫికేషన్ చాట్లు\" ఎంపికను మీరు ఫైల్‌లో ధృవీకరించిన ఇమెయిల్ చిరునామా ఉన్నప్పుడు మాత్రమే సక్రియం చేయవచ్చు.",
  stored_email: "సేవ్ చేసిన ఇమెయిల్: ",
  verify_email: "నిర్ధారణ పెండింగ్‌లో!",
  join_call: "చేరండి",
  call_is_started: "కాల్ ప్రారంభమైంది",
  start_chat: "నేరుగా-చాట్ ప్రారంభించాలా?",
  project_rooms: "ప్రాజెక్టులు",
  download_selected: "డౌన్‌లోడ్ చేయండి",
  add_employee_confirm: 'మీరు నిజంగా ఈ వినియోగదారుని కంపెనీకి జోడించాలనుకుంటున్నారా?',
  invalid_deeplink: "చెల్లని deeplink URL. అవసరమైన పారామితులు లేవు.",
  deeplink_error: "deeplinkను ప్రాసెస్ చేయడం సాధ్యం కాదు. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.",
  reply: "సమాధానం",
  reply_enter: "సమాధానం నమోదు చేయండి...",
  reply_sent_successfully: "సమాధానం విజయవంతంగా పంపబడింది",
  reply_failed: "సమాధానం పంపడంలో విఫలమైంది",
  reply_failed_generic: "సమాధానం పంపడంలో విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
  replying_to_message: "సందేశానికి సమాధానం ఇస్తోంది",
  cancel_reply: "సమాధానం రద్దు చేయండి",
  voice_message: "వాయిస్ సందేశం",
  send: "పంపండి",
  cancel: "రద్దు చేయండి",
  type_your_reply: "మీ సమాధానాన్ని టైప్ చేయండి...",
  suggested_replies: "సూచించిన సమాధానాలు",
  suggestions_error: "సూచనలను లోడ్ చేయడంలో విఫలమైంది",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "ఒక క్షణం. మీ టెక్స్ట్ మీ కోసం వ్యక్తిగతంగా సిద్ధం చేయబడుతోంది.",
  loading_chat_message: "చాట్ లోడ్ అవుతోంది...",
  extracting_message: "సందేశాన్ని సంగ్రహిస్తోంది...",
  create_todo: "ToDo సృష్టించండి",
  add_to_todo: "ToDoకి జోడించండి",
  remove_from_todo: "ToDo నుండి తొలగించండి",
  create_todo_confirmation: "మీరు ఈ సందేశం నుండి ToDo సృష్టించాలనుకుంటున్నారా?",
  select_project_required: "దయచేసి ఒక ప్రాజెక్ట్/గ్రూప్‌ను ఎంచుకోండి",
  only_assigned_can_change_status: "కేటాయించిన వినియోగదారులు మాత్రమే స్థితిని మార్చగలరు",
  todo_summary: "సారాంశం",
  todo_summary_placeholder: "todo సారాంశాన్ని నమోదు చేయండి...",
  todo_date: "తేదీ",
  todo_time: "సమయం",
  todo_date_hint: "అసలు సందేశం తేదీ/సమయాన్ని ఉపయోగించడానికి ఖాళీగా ఉంచండి",
  todo_created_success: "ToDo విజయవంతంగా సృష్టించబడింది",
  todo_creation_failed: "ToDo సృష్టించడంలో విఫలమైంది",
  create: "సృష్టించండి",
  // Member Selection
  error_loading_members: "సభ్యులను లోడ్ చేయడంలో లోపం",
  please_fill_all_fields: "దయచేసి అన్ని ఫీల్డ్‌లను పూరించండి",
  invalid_email: "చెల్లని ఇమెయిల్ చిరునామా",
  member_added_successfully: "సభ్యుడు విజయవంతంగా జోడించబడ్డాడు",
  error_onboarding_user: "వినియోగదారుని జోడించడంలో లోపం",
  error_creating_chat: "చాట్ సృష్టించడంలో లోపం",
  error_creating_group: "గ్రూప్ సృష్టించడంలో లోపం",
  new_group: "కొత్త గ్రూప్",
  please_select_or_enter_group_name: "దయచేసి గ్రూప్‌ను ఎంచుకోండి లేదా గ్రూప్ పేరును నమోదు చేయండి",
  please_select_or_enter_room_name: "దయచేసి ప్రాజెక్ట్‌ను ఎంచుకోండి లేదా ప్రాజెక్ట్ పేరును నమోదు చేయండి",
  error_creating_room: "ప్రాజెక్ట్ సృష్టించడంలో లోపం",
  error_opening_chat: "చాట్ తెరవడంలో లోపం",
  privacy_modal_text: "చాట్ ప్రాజెక్ట్ మేనేజర్‌కు సంబంధించిన వృత్తిపరమైన కంటెంట్‌ను కలిగి ఉండకపోతే మాత్రమే \"ప్రైవేట్\" ఎంచుకోండి.",
  not_private: "ప్రైవేట్ కాదు",
  private: "ప్రైవేట్",
  error_loading_groups: "గ్రూప్‌లను లోడ్ చేయడంలో లోపం",
  automatic_chat_export: "స్వయంచాలక చాట్ ఎగుమతి",
  automatic_chat_export_info: "సక్రియం తర్వాత, చాట్ చరిత్ర ప్రతి నెల నిర్దిష్ట ఇమెయిల్ చిరునామాకు స్వయంచాలకంగా పంపబడుతుంది.",
  automatic_chat_export_no_email: "స్వయంచాలక చాట్ ఎగుమతిని ప్రారంభించడానికి, మీరు మొదట ఇమెయిల్ చిరునామాను జోడించాలి. మీరు మీ ఇమెయిల్ చిరునామాను వ్యక్తిగత సెట్టింగ్‌లలో జోడించవచ్చు.",
  enter_email: "ఇమెయిల్ నమోదు చేయండి",
  update: "నవీకరించండి",
  confirm: "నిర్ధారించండి",
  export_to_email: "ఎగుమతి కింది ఇమెయిల్‌కు వెళుతుంది.",
  start_chat_button:"కొత్త సందేశం",
  matching_existing_chats: "అస్తిత్వంలో ఉన్న చాట్‌లతో సరిపోలుతోంది",
  subject: "విషయం",
  add_subject: "విషయాన్ని జోడించండి",
  chat_subject: "చాట్ విషయం:",
  set_project_room: "ప్రాజెక్ట్‌ను సెట్ చేయండి",
  matching_existing_project_rooms: "అస్తిత్వంలో ఉన్న ప్రాజెక్టులతో సరిపోలుతోంది",
  name_project_room: "ప్రాజెక్ట్‌కు పేరు పెట్టండి",
  professional_or_private: "వృత్తిపరమైన లేదా ప్రైవేట్",
  professional: "వృత్తిపరమైన",
  privacy_modal_text_updated: "చాట్ ప్రాజెక్ట్ మేనేజర్‌లకు సంబంధించిన వృత్తిపరమైన కంటెంట్‌ను కలిగి ఉండకపోతే మాత్రమే \"ప్రైవేట్\" ఎంచుకోండి. ప్రైవేట్ చాట్‌లు ప్రాజెక్ట్ మేనేజర్‌లకు కనిపించవు.",
  create_internal_chat: "బాహ్య - లేదా అంతర్గత చాట్?",
  internal_chat_description: "మీ కంపెనీ ఉద్యోగులు మాత్రమే అంతర్గత చాట్‌లకు జోడించబడతారు.",
  yes: "అవును",
  no: "కాదు",
  chat_is_being_created: "చాట్ సృష్టించబడుతోంది...",
  // Additional translations for hardcoded text
  discard_article_confirm: "ఈ వ్యాసంలోని మార్పులను మీరు నిజంగా విస్మరించాలనుకుంటున్నారా?",
  please_enter_article_title: "దయచేసి ముందుగా వ్యాస శీర్షికను నమోదు చేయండి.",
  please_add_mandatory_fields: "దయచేసి అన్ని తప్పనిసరి ఫీల్డ్‌లను జోడించండి",
  product_label: "ఉత్పత్తి:",
  no_companies_found: "కంపెనీలు కనుగొనబడలేదు",
  visible_to_all_followers: "అన్ని Kjuup సభ్యులకు కనిపిస్తుంది",
  only_visible_to_employees: "ఉద్యోగులకు మాత్రమే కనిపిస్తుంది",
  something_went_wrong: "ఏదో తప్పు జరిగింది, దయచేసి మళ్లీ ప్రయత్నించండి",
  please_select_department: "దయచేసి విభాగం/స్థానాన్ని ఎంచుకోండి",
  schedule: "షెడ్యూల్",
  please_select_future_date_time: "దయచేసి వ్యాసాన్ని షెడ్యూల్ చేయడానికి భవిష్యత్ తేదీ మరియు సమయాన్ని ఎంచుకోండి.",
  please_select_different_date_time: "దయచేసి వ్యాసాన్ని షెడ్యూల్ చేయడానికి వేరే తేదీ లేదా సమయాన్ని ఎంచుకోండి.",
  please_select_later_time: "దయచేసి నేటికి ప్రస్తుత సమయం కంటే తర్వాత సమయాన్ని ఎంచుకోండి.",
  unpin_article: "వ్యాసాన్ని అన్‌పిన్ చేయండి",
  pin_article: "వ్యాసాన్ని పిన్ చేయండి",
  and: "మరియు",
  others: "ఇతరులు",
  at: "వద్ద",
  // Chat mute/unmute translations
  mute: "మ్యూట్",
  unmute: "అన్‌మ్యూట్",
  chat_muted_successfully: "చాట్ విజయవంతంగా మ్యూట్ చేయబడింది",
  chat_unmuted_successfully: "చాట్ విజయవంతంగా అన్‌మ్యూట్ చేయబడింది",
  mute_chat_confirm: "మీరు నిజంగా ఈ చాట్‌ను మ్యూట్ చేయాలనుకుంటున్నారా? మీరు కొత్త సందేశాలకు నోటిఫికేషన్‌లను ఇకపై పొందరు.",
  unmute_chat_confirm: "మీరు నిజంగా ఈ చాట్‌ను అన్‌మ్యూట్ చేయాలనుకుంటున్నారా? మీరు మళ్లీ కొత్త సందేశాలకు నోటిఫికేషన్‌లను పొందుతారు.",
  please_select_group_to_forward: "దయచేసి సందేశాన్ని ఫర్వార్డ్ చేయడానికి గ్రూప్‌ను ఎంచుకోండి",
  // Company translations
  record_not_found: "రికార్డ్ కనుగొనబడలేదు!",
  please_select_position: "దయచేసి స్థానాన్ని ఎంచుకోండి",
  delete_article_confirm: "మీరు నిజంగా ఈ వ్యాసాన్ని తొలగించాలనుకుంటున్నారా?",
  delete_company_service_confirm: "మీరు నిజంగా కంపెనీ సేవను తొలగించాలనుకుంటున్నారా?",
  block_translation_confirm: "మీరు నిజంగా కంపెనీలోని అన్ని సభ్యులకు ప్రాజెక్టులలో స్వయంచాలక అనువాదాన్ని బ్లాక్ చేయాలనుకుంటున్నారా",
  unblock_translation_confirm: "మీరు నిజంగా కంపెనీలోని అన్ని సభ్యులకు ప్రాజెక్టులలో స్వయంచాలక అనువాదాన్ని అన్‌బ్లాక్ చేయాలనుకుంటున్నారా",
  please_select_file: "దయచేసి అప్‌లోడ్ చేయడానికి ఫైల్‌ను ఎంచుకోండి",
  role_in_building_industry: "నిర్మాణ పరిశ్రమలో పాత్ర*",
  invalid_email_address: "చెల్లని ఇమెయిల్ చిరునామా",
  please_enter_password: "దయచేసి పాస్వర్డ్ నమోదు చేయండి",
  password_change_email_sent: "మీ Kjuup ఇమెయిల్‌కు ఒక ఇమెయిల్ పంపబడింది. ఇమెయిల్‌లోని నిర్ధారణ లింక్‌పై క్లిక్ చేయడం ద్వారా మీ కొత్త పాస్‌వర్డ్‌ను నిర్ధారించండి.",
  please_enter_username: "దయచేసి వినియోగదారు పేరును నమోదు చేయండి",
  username_same_as_before: "వినియోగదారు పేరు మునుపటిలా ఉండకూడదు",
  profile_deleted_successfully: "ప్రొఫైల్ విజయవంతంగా తొలగించబడింది",
  hardware_requirements: "హార్డ్‌వేర్ అవసరాలు",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU వేగం కనీసం 2GHz<br/>• Windows 7 లేదా అధిక / అన్ని macOS వెర్షన్‌లు",
  submitting: "సమర్పిస్తోంది...",
  signing_in: "సైన్ ఇన్ అవుతోంది...",
  please_enter_service_name: "దయచేసి సేవ పేరును నమోదు చేయండి",
  something_went_wrong_error: "ఆహ్! ఏదో తప్పు జరిగింది...",
  something_went_wrong_try_again: "క్షమించండి, అక్కడ ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి",
  position_label: "స్థానం:",
  loading_room: "ప్రాజెక్ట్ లోడ్ అవుతోంది...",
  navigating_to_room: "ప్రాజెక్ట్‌కు నావిగేట్ చేస్తోంది",
  loading_chat: "చాట్ లోడ్ అవుతోంది...",
  translate: "అనువదించండి",
  show_original: "అసలు చూపించండి",
  saving: "సేవ్ అవుతోంది...",
  language_selection_info: "భాష ఎంపిక కంపెనీకి సంబంధించిన అన్ని ఇమెయిల్ నిర్ధారణలకు ఉపయోగించబడుతుంది.",
  // Navigation bar labels
  nav_call: "కాల్",
  nav_home: "హోమ్",
  nav_messages: "సందేశాలు",
  nav_todo: "పనులు",
  nav_rooms: "ప్రాజెక్టులు",
  nav_all_rooms: "అన్ని ప్రాజెక్టులు",
  pinned_rooms_max: "మీరు 10 ప్రాజెక్టుల వరకు పిన్ చేయవచ్చు.",
  pinned_room_unpin: "పిన్ తీయండి",
  pinned_rooms_drop: "త్వరిత ఎంపిక కోసం మీ ప్రాజెక్ట్‌ను ఇక్కడకు లాగండి",
  nav_profile: "ప్రొఫైల్",
  nav_company: "కంపెనీ",
  nav_company_documents: "పత్రాలు",
  nav_logout: "లాగ్అవుట్",
  // Create message dialog
  add_member_title: "సభ్యుడిని జోడించండి",
  continue_btn: "కొనసాగించండి",
  search_placeholder: "శోధించండి",
  no_members_found: "సభ్యులు కనుగొనబడలేదు",
  no_groups_found: "గ్రూప్‌లు కనుగొనబడలేదు",
  no_rooms_found: "ప్రాజెక్టులు కనుగొనబడలేదు",
  search_users_tab: "వినియోగదారులు",
  search_documents_tab: "పత్రాలు",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "ఫైళ్లు లేవు",
  no_documents_available: "No documents",
  searching_users: "వినియోగదారులను వెతుకుతోంది...",
  no_users_found: "వినియోగదారులు కనుగొనబడలేదు",
  search_emails_tab: "ఇమెయిల్",
  searching_emails: "ఇమెయిల్‌లను శోధిస్తోంది...",
  no_emails_found: "ఇమెయిల్‌లు కనుగొనబడలేదు",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "పేరు లేని గ్రూప్",
  unnamed_room: "పేరు లేని ప్రాజెక్ట్",
  all_members: "అన్నీ",
  room_label: "ప్రాజెక్ట్:",
  subject_label: "విషయం:",
  no_members: "సభ్యులు లేరు",
  // Loading states for room creation
  creating_structure: "మీ నిర్మాణాన్ని సృష్టిస్తోంది",
  opening_chat: "చాట్‌ను తెరుస్తోంది",
  please_wait: "దయచేసి వేచి ఉండండి...",
  // ToDo page translations
  loading_todo: "ToDo లోడ్ అవుతోంది...",
  task_updated: "టాస్క్ నవీకరించబడింది",
  error_updating_task: "టాస్క్ నవీకరించడంలో లోపం",
  task_deleted: "టాస్క్ తొలగించబడింది",
  error_deleting_task: "టాస్క్ తొలగించడంలో లోపం",
  delete_task_confirm: "మీరు నిజంగా ఈ టాస్క్‌ను తొలగించాలనుకుంటున్నారా?",
  description_label: "వివరణ",
  description_placeholder: "వివరణను నమోదు చేయండి...",
  date_time_label: "తేదీ మరియు సమయం",
  save_hint: "సేవ్ చేయడానికి Ctrl+Enter, రద్దు చేయడానికి Esc",
  edit_label: "సవరించండి",
  delete_label: "తొలగించండి",
  todo_list_title: "పనులు",
  tasks_count: "టాస్క్‌లు",
  search_placeholder_todo: "శోధించండి...",
  select_task_to_open_chat: "చాట్ తెరవడానికి టాస్క్‌ను ఎంచుకోండి",
  today: "ఈరోజు",
  yesterday: "నిన్న",
  time_suffix: "", // Empty for Telugu (24h format doesn't need suffix)
  from_chat: "మూల ToDo",
  assigned_to: "కేటాయించబడింది",
  assign_users: "వినియోగదారులను కేటాయించండి",
  no_users_assigned: "వినియోగదారులు కేటాయించబడలేదు",
  assign: "కేటాయించండి",
  assign_to: "కేటాయించండి...",
  navigate_to_chat: "చాట్‌కు నావిగేట్ చేయండి",
  navigate_to_email: "ఇమెయిల్‌కు వెళ్లండి",
  show_original_message: "మూలాన్ని చూపించండి",
  hide_original_message: "మూలాన్ని దాచండి",
  status_pending: "పెండింగ్",
  status_in_progress: "ప్రగతిలో ఉంది",
  status_completed: "పూర్తయింది",
  show: "చూపించండి",
  close: "మూసివేయండి",
  status_confirmed: "[నిర్ధారించబడింది]",
  log_todo_created: "ToDo [సృష్టించబడింది]",
  log_todo_confirmed: "ToDo [నిర్ధారించబడింది]",
  log_todo_deleted: "ToDo [తొలగించబడింది]",
  log_todo_updated: "ToDo [నవీకరించబడింది]",
  log_description_updated: "[వివరణ నవీకరించబడింది]",
  log_deadline_updated: "[గడువు నవీకరించబడింది]",
  log_assigned_to: "[కేటాయించబడింది] {name}",
  log_unassigned_from: "[కేటాయింపు తొలగించబడింది] {name}",
  log_assignment_added: "[కేటాయింపు జోడించబడింది]: {name}",
  log_assignment_removed: "[కేటాయింపు తొలగించబడింది]: {name}",
  log_status_updated: "[స్థితి మారింది] {from} [నుండి] {to}",
  log_status_changed: "[స్థితి మారింది]",
  log_status_changed_to: "[స్థితి మారింది] {status}",
  log_changed_status_to: "[స్థితి మారింది]:",
  log_for_user: "[వినియోగదారు కోసం]:",
  log_user_updated_status: "[వినియోగదారు వారి todo స్థితిని నవీకరించారు]",
  log_changed_date_to: "[తేదీ మారింది]:",
  log_changed_description_to: "[వివరణ మారింది]:",
  log_moved_to: "[తరలించబడింది] {status}",
  todo_status_updated_from: "[నుండి]",
  todo_status_updated_to: "[కు]",
  filter_pending: "పెండింగ్",
  filter_confirmed: "నిర్ధారించబడింది",
  filter_assigned_to_me: "నా పనులు",
  filter_assigned_by_me: "అప్పగించబడింది",
  todo_project_label: "ప్రాజెక్ట్:",
  assigned_users: "కేటాయించిన వినియోగదారులు:",
  todo_chat_label: "చాట్:",
  history: "చరిత్ర",
  todo_assigned_by: "కేటాయించినవారు:",
  todo_assigned_push: "కేటాయించిన ToDo:",
  todo_assigned_push_empty: "మీకు కొత్త ToDo కేటాయించబడింది.",
  search_groups: "గ్రూప్‌లు",
  search_chat_groups: "చాట్ గ్రూప్‌లు",
  search_project_room: "ప్రాజెక్ట్",
  search_messages: "సందేశాలు, చాట్ గ్రూప్‌లు, ప్రాజెక్టులు మరియు వినియోగదారులను వెతకండి...",
  search_messages_tab: "సందేశాలు",
  searching_groups: "గ్రూప్‌లను వెతుకుతోంది...",
  searching_rooms: "ప్రాజెక్టులను వెతుకుతోంది...",
  no_groups_found: "గ్రూప్‌లు కనుగొనబడలేదు",
  no_rooms_found: "ప్రాజెక్టులు కనుగొనబడలేదు",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_step_processing: "లిప్యంతరీకరణ జరుగుతోంది...",
  ai_transcript_tab: "AI-లిప్యంతరీకరణ",
  ai_transcript_info: "09.03.2026 తర్వాత సృష్టించిన వాయిస్ సందేశాలకు మాత్రమే అందుబాటులో ఉంటుంది.",
  transcript_more: "...మరిన్ని",
  transcript_less: "...తక్కువ",
  ki_transcript_voice_message: "KI-వాయిస్ మెసేజ్ ట్రాన్స్‌క్రిప్ట్",
  ki_image_analysis: "AI-ఆధారిత చిత్ర విశ్లేషణ",
  type_message: "సందేశం టైప్ చేయండి",
  email_tab_messages: "సందేశాలు",
  email_tab_email: "ఇమెయిల్",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "ఇమెయిల్ ఖాతాలు",
  email_connect_gmail: "Gmail కనెక్ట్ చేయండి",
  email_connect_outlook: "Outlook కనెక్ట్ చేయండి",
  email_no_accounts: "కనెక్ట్ చేయబడిన ఇమెయిల్ ఖాతాలు లేవు",
  email_no_accounts_hint: "మీ ప్రొఫైల్ సెట్టింగ్‌లలో ఇమెయిల్ ఖాతాను కనెక్ట్ చేయండి",
  email_no_messages: "ఇమెయిల్‌లు లేవు",
  email_from: "నుండి",
  email_to: "కు",
  email_subject: "విషయం",
  email_disconnect: "డిస్‌కనెక్ట్ చేయండి",
  email_disconnect_confirm: "మీరు ఈ ఇమెయిల్ ఖాతాను డిస్‌కనెక్ట్ చేయాలనుకుంటున్నారా? సింక్ చేయబడిన అన్ని ఇమెయిల్‌లు తొలగించబడతాయి.",
  email_account_disconnected: "ఇమెయిల్ ఖాతా విజయవంతంగా డిస్‌కనెక్ట్ చేయబడింది",
  email_account_disconnect_failed: "ఖాతాను డిస్‌కనెక్ట్ చేయడం విఫలమైంది",
  email_connecting: "కనెక్ట్ అవుతోంది...",
  email_account_connected: "ఖాతా విజయవంతంగా కనెక్ట్ అయింది",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "సెట్టింగ్‌లకు వెళ్లండి",
  email_date: "తేదీ",
  email_reply: "ప్రత్యుత్తరం",
  email_forward: "ఫార్వార్డ్ చేయండి",
  email_copy_text: "టెక్స్ట్ కాపీ చేయండి",
  email_text_copied: "కాపీ చేయబడింది!",
  email_text_copy_failed: "టెక్స్ట్‌ను కాపీ చేయడం సాధ్యపడలేదు.",
  email_delete: "తొలగించండి",
  email_not_spam: "స్పామ్ కాదు",
  email_not_spam_success: "ఇమెయిల్ ఇన్‌బాక్స్‌కు తరలించబడింది.",
  email_not_spam_failed: "ఇన్‌బాక్స్‌కు తరలించడం విఫలమైంది.",
  email_delete_confirm: "మీరు ఈ ఇమెయిల్‌ను తొలగించాలనుకుంటున్నారా?",
  email_delete_from_folder: "మీరు {folder} నుండి తొలగించాలనుకుంటున్నారా?",
  email_delete_permanent_from_folder:
    "మీరు {folder} నుండి శాశ్వతంగా తొలగించాలనుకుంటున్నారా? ఈ చర్యను రద్దు చేయలేరు.",
  email_save_draft_confirm: "ఈ ఇమెయిల్‌ను డ్రాఫ్ట్‌గా సేవ్ చేయాలనుకుంటున్నారా?",
  email_save_draft: "డ్రాఫ్ట్ సేవ్",
  email_discard: "విస్మరించు",
  email_back_to_compose: "రాయడానికి తిరిగి వెళ్ళు",
  email_draft_saved: "డ్రాఫ్ట్ సేవ్ చేయబడింది.",
  email_draft_save_failed: "డ్రాఫ్ట్ సేవ్ చేయడం విఫలమైంది.",
  email_loading: "ఇమెయిల్‌లు లోడ్ అవుతున్నాయి...",
  unavailability_note: "అందుబాటులో లేని గమనిక",
  unavailability_description: "ఆఫీసులో లేరు అనే గమనికను సెట్ చేయండి. సక్రియంగా ఉన్నప్పుడు, గమనిక మీ అన్ని చాట్లలో ఇతరులకు చూపబడుతుంది మరియు నోటిఫికేషన్లు పాజ్ చేయబడతాయి.",
  unavailability_start_date: "ప్రారంభ తేదీ",
  unavailability_end_date: "ముగింపు తేదీ",
  unavailability_message: "సందేశం",
  unavailability_message_hint: "మీ రిటర్న్ తేదీకి {endDate} ను ప్లేస్‌హోల్డర్‌గా ఉపయోగించండి.",
  unavailability_replacement: "ప్రత్యామ్నాయ సంప్రదింపు",
  unavailability_replacement_placeholder: "అత్యవసర అభ్యర్థనల కోసం వినియోగదారు ఐడీ నమోదు చేయండి",
  unavailability_replacement_current: "ప్రస్తుత ప్రత్యామ్నాయం",
  unavailability_replacement_hint: "సెట్ చేసినట్లయితే, అత్యవసర విషయాల కోసం ఈ వ్యక్తిని సంప్రదించడానికి లింక్ మీ అందుబాటులో లేని గమనికలో చూపబడుతుంది.",
  unavailability_replacement_none: "ప్రత్యామ్నాయం లేదు (ఐచ్ఛికం)",
  unavailability_contact_urgent: "అత్యవసర అభ్యర్థనల కోసం సంప్రదించండి",
  unavailability_default_message: "నేను ప్రస్తుతం కార్యాలయంలో లేను మరియు Kjuup యాక్సెస్ లేదు. {endDate} నుండి మళ్ళీ అందుబాటులో ఉంటాను మరియు అప్పుడు మిమ్మల్ని సంప్రదిస్తాను.",
  unavailability_save: "సేవ్ చేయండి",
  unavailability_deactivate: "నిష్క్రియం చేయండి",
  unavailability_active_until: "వరకు సక్రియం",
  unavailability_saved: "అందుబాటులో లేని గమనిక సేవ్ చేయబడింది",
  unavailability_save_error: "అందుబాటులో లేని గమనిక సేవ్ చేయడంలో విఫలమైంది",
  unavailability_deactivated: "అందుబాటులో లేని గమనిక నిష్క్రియం చేయబడింది",
  unavailability_end_date_required: "ముగింపు తేదీ అవసరం",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "ప్రివ్యూ అందుబాటులో లేదు",
  email_preview_failed: "ప్రివ్యూ అందుబాటులో లేదు",
  select_attachments: "అటాచ్‌మెంట్‌లను ఎంచుకోండి",
  email_loading_preview: "Loading preview...",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  filter_all: "అన్నీ",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "నేరుగా సందేశాలు",
  my_notes: "My Space",
  filter_internal_groups: "అంతర్గత సమూహ చాట్‌లు",
  filter_external_groups: "బాహ్య సమూహ చాట్‌లు",
  filter_group_chats: "సమూహ చాట్‌లు",
  filter_groups_internal: "అంతర్గత",
  filter_groups_external: "బాహ్య",
  filter_unread_only: "చదవనివి మాత్రమే",
  room_daily_briefing_info: "ప్రారంభించినప్పుడు, వ్యక్తిగత సెట్టింగ్‌లలో పేర్కొన్న సమయానికి ప్రతి 24 గంటలకు ఈ ప్రాజెక్ట్ నివేదిక రూపొందించబడుతుంది — కానీ ఆ కాలంలో కార్యకలాపం ఉంటే మాత్రమే.",
  email_select_all: "అన్నీ ఎంచుకోండి",
  email_deselect_all: "అన్నింటినీ ఎంపిక తొలగించు",
  email_reply_all: "అందరికీ జవాబివ్వండి",
  email_reply_placeholder: "మీ జవాబును టైప్ చేయండి...",
  email_forward_placeholder: "సందేశం జోడించండి...",
  email_edit_draft: "డ్రాఫ్ట్ సవరించు",
  email_attach: "జోడించు",
  email_attachment_from_original: "అసలు సందేశం నుండి",
  email_remove: "తొలగించు",
  email_drop_files: "జోడించడానికి ఫైల్‌లను డ్రాప్ చేయండి",
  email_loading_attachments: "అటాచ్‌మెంట్‌లు లోడ్ అవుతున్నాయి...",
  email_archive: "ఆర్కైవ్",
  mark_unread: "చదవనిదిగా గుర్తించు",
  mark_read: "చదివినదిగా గుర్తించు",
  email_all_accounts: "అన్ని ఖాతాలు",
  email_error: "లోపం",
  email_delete_email_failed: "ఇమెయిల్ తొలగించడం విఫలమైంది.",
  enter_url: "URL నమోదు చేయండి",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'ఇప్పుడే సబ్‌స్క్రైబ్ చేయండి',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1నెల ఉచిత ట్రయల్',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'ఈరోజు చెల్లింపు లేదు. చెల్లింపు సబ్‌స్క్రిప్షన్ ప్రారంభమయ్యే ముందు క్రెడిట్ కార్డ్ వివరాలు అడగరు.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'అన్ని ఇమెయిల్ ఖాతాలను నేరుగా Kjuupలో నిర్వహించండి',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI సమాధానాలు రాస్తుంది – మీరు నిర్ధారించండి మాత్రమే',
  kjuup_io_feature_tasks: 'టాస్క్‌లు & క్యాలెండర్ ఎల్లప్పుడూ స్వయంచాలకంగా అప్‌డేట్',
  kjuup_io_choose_plan: 'ప్లాన్ ఎంచుకోండి',
  kjuup_io_plan_monthly: 'నెలవారీ',
  kjuup_io_plan_yearly: 'వార్షికం',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe ద్వారా సురక్షితం · ఎప్పుడైనా రద్దు చేయవచ్చు',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'చెల్లింపు అందింది. మీ సబ్‌స్క్రిప్షన్‌ను యాక్టివేట్ చేస్తోంది…',
  kjuup_io_toast_activating_soon: 'చెల్లింపు అందింది. మీ సబ్‌స్క్రిప్షన్ త్వరలో యాక్టివేట్ అవుతుంది.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} గంటలు మిగిలి ఉన్నాయి',
  kjuup_io_trial_left_hour: '1 గంట మిగిలి ఉంది',
  kjuup_io_trial_left_minutes: '{count} నిమిషాలు మిగిలి ఉన్నాయి',
  kjuup_io_trial_left_minute: '1 నిమిషం మిగిలి ఉంది',
  kjuup_io_trial_left_seconds: '{count} సెకన్లు మిగిలి ఉన్నాయి',
  kjuup_io_trial_left_second: '1 సెకను మిగిలి ఉంది',
  kjuup_io_trial_ending_now: 'మీ ట్రయల్ ముగుస్తోంది…',
  kjuup_io_request_timeout: 'కనెక్షన్ సమయం ముగిసింది. దయచేసి మళ్లీ ప్రయత్నించండి.',
  kjuup_io_info_days_free: '{days} రోజులు పూర్తిగా ఉచితం – సబ్‌స్క్రిప్షన్ ట్రయల్ తర్వాతే ప్రారంభమవుతుంది.',
  kjuup_io_discount_total: 'మీ తగ్గింపు: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'వ్యక్తిగతం: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'మూసివేయండి',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'మీ ఉచిత ట్రయల్ ముగిసింది',
  kjuup_io_trial_ended_body: 'ఇమెయిల్ మరియు ఇతర ప్రీమియం ఫీచర్లను ఉపయోగించడం కొనసాగించడానికి Kjuup.ioకు సబ్‌స్క్రైబ్ చేయండి.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'మీ ఉచిత ట్రయల్ ప్రారంభమైంది',
  kjuup_io_toast_trial_fail: 'ఉచిత ట్రయల్‌ను ప్రారంభించలేకపోయాము',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / నెల',
  kjuup_io_save_amount_year: 'సంవత్సరానికి {price} ఆదా',
  kjuup_io_billed_annually_amount: '{price} వార్షిక బిల్లింగ్',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'మీకు లభించేది:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'క్రెడిట్ కార్డ్ అవసరం లేదు – చెల్లింపు వివరాలు లేకుండా వెంటనే ప్రారంభించండి.',
  kjuup_io_info_cancel_anytime: 'ఎప్పుడైనా రద్దు చేయండి – బాధ్యత లేదు, రిస్క్ లేదు.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'బిల్లింగ్ వ్యవధి',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'చెల్లింపు విధానం సేవ్ చేయబడింది. ట్రయల్ ముగిసినప్పుడు ఛార్జ్ చేయబడుతుంది.',
  calendar_sync_info: 'అన్ని Kjuup ToDoలను మీ క్యాలెండర్‌తో స్వయంచాలకంగా సింక్ చేయండి.',
  calendar_no_accounts: 'ఇంకా క్యాలెండర్ కనెక్ట్ కాలేదు.',
  article_new_badge: 'కొత్తది',
  article_new_posts: '{0} కొత్త పోస్ట్‌లు',
  documents: 'పత్రాలు',
  add_documents: 'పత్రాలను జోడించండి',
  no_preview_available: 'ప్రివ్యూ అందుబాటులో లేదు',
  no_preview_hint: 'ఈ రకమైన ఫైల్‌ను ప్రివ్యూ చేయలేము, కానీ అది పంపబడుతుంది.',
  max_documents_reached: 'ఒకేసారి గరిష్ఠంగా 10 పత్రాలను జతచేయవచ్చు.',
  open_file: 'ఫైల్‌ను తెరవండి',
  twofa_title: 'రెండు-దశల ప్రమాణీకరణ',
  twofa_method_totp: 'ఆథెంటికేటర్ యాప్',
  twofa_method_sms: 'టెక్స్ట్ సందేశం',
  twofa_method_email: 'ఇమెయిల్',
  twofa_enter_app: 'మీ ఆథెంటికేటర్ యాప్ నుండి 6 అంకెల కోడ్ నమోదు చేయండి.',
  twofa_enter_sms: 'SMS ద్వారా పంపిన 6 అంకెల కోడ్ నమోదు చేయండి.',
  twofa_enter_email: 'ఇమెయిల్‌కు పంపిన 6 అంకెల కోడ్ నమోదు చేయండి.',
  twofa_resend: 'కోడ్ మళ్లీ పంపండి',
  twofa_try_another: 'మరొక పద్ధతి ప్రయత్నించం�ొక పద్ధతి ప్రయత్నించండి',
  twofa_remember_device: 'ఈ పరికరంలో 30 రోజులు అడగవద్దు',
  twofa_sent: 'మేము ఒక కోడ్ పంపాము.',
  twofa_invalid_code: 'ఈ కోడ్ తప్పు. దయచేసి మళ్లీ ప్రయత్నించండి.',
  twofa_something_wrong: 'ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.',
  twofa_method_unavailable: 'ఈ ధృవీకరణ పద్ధతి అందుబాటులో లేదు.',
  twofa_on_desc: 'రెండు-దశల ప్రమాణీకరణ ఆన్‌లో ఉంది. ప్రతి సైన్ ఇన్‌కు కోడ్ కావాలి.',
  twofa_off_desc: 'పాస్‌వర్డ్ తర్వాత రెండవ దశను జోడించండి. ఆథెంటికేటర్ యాప్‌లు అత్యంత సురక్షితం.',
  twofa_methods: 'పద్ధతులు',
  twofa_on: 'ఆన్',
  twofa_add: 'జోడించు',
  twofa_default_method: 'డిఫాల్ట్ పద్ధతి',
  twofa_default: 'డిఫాల్ట్',
  twofa_turn_off: 'ఆఫ్ చేయి',
  twofa_disable_hint: 'రెండు-దశల ప్రమాణీకరణను ఆఫ్ చేయడానికి పాస్‌వర్డ్ మరియు ప్రస్తుత కోడ్ నమోదు చేయండి.',
  twofa_disable_need: 'పాస్‌వర్డ్ మరియు ధృవీకరణ కోడ్ నమోదు చేయండి.',
  twofa_code_placeholder: '6 అంకెల కోడ్ లేదా బ్యాకప్ కోడ్',
  twofa_send_code: 'కోడ్ పంపండి',
  twofa_primary_updated: 'డిఫాల్ట్ పద్ధతి నవీకరించబడింది.',
  twofa_disabled: 'రెండు-దశల ప్రమాణీకరణ ఇప్పుడు ఆఫ్‌లో ఉంది.',
  twofa_enabled: 'రెండు-దశల ప్రమాణీకరణ ఇప్పుడు ఆన్‌లో ఉంది.',
  twofa_totp_help: 'ఈ QR కోడ్‌ను Google Authenticator, Authy లేదా 1Passwordతో స్కాన్ చేయండి. కీని మాన్యు�్ చేయండి. కీని మాన్యువల్‌గా కూడా నమోదు చేయవచ్చు.',
  twofa_secret_copied: 'కీ కాపీ అయింది',
  twofa_sms_help: 'అంతర్జాతీయ ఫార్మాట్‌లో మొబైల్ నంబర్ నమోదు చేయండి. 6 అంకెల కోడ్ SMS ద్వారా పంపుతాం.',
  twofa_email_help: 'మీ ఖాతా ఇమెయిల్‌కు 6 అంకెల కోడ్ పంపుతాం.',
  twofa_backup_title: 'బ్యాకప్ కోడ్‌లు',
  twofa_backup_help: 'ఈ ఒకసారి కోడ్‌లను సురక్షి�కసారి కోడ్‌లను సురక్షితంగా ఉంచండి. ఫోన్ పోతే ప్రతి కోడ్ ఒకసారి వాడవచ్�తి కోడ్ ఒకసారి వాడవచ్చు.',
  twofa_copy_codes: 'కోడ్‌లను కాపీ చేయండి',
  twofa_codes_copied: 'బ్యాకప్ కోడ్‌లు కాపీ అయ్యాయి',
  twofa_regenerate: 'కొత్త బ్యాకప్ కోడ్‌లు పొందండి',
  twofa_regenerate_hint: 'ఇది ఉపయోగించని బ్యాకప్ కోడ్‌లను భర్తీ చేస్తుంది. పాస్‌వర్డ్ మరియు ప్రస్తుత కోడ్‌ను నమోదు చేయండి.',
  twofa_backup_remaining: '{n} ఉపయోగించని బ్యాకప్ కోడ్‌లు మిగిలి ఉన్నాయి',
  twofa_new_codes: 'కొత్త బ్యాకప్ కోడ్‌లు',
  twofa_sms_unavailable: 'SMS కోడ్‌లు ఇంకా అందుబాటులో లేవు.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "మీకు కేటాయించిన Kjuup పనులు మీ Todoistలోని Kjuup ప్రాజెక్ట్‌లోకి కాపీ అవుతాయి. Todoistలో చేసిన మార్పులు తిరిగి కాపీ కావు.",
  todoist_connect: "Todoist కనెక్ట్ చేయండి",
  todoist_connected: "Todoist కనెక్ట్ అయింది",
  todoist_connect_failed: "Todoist కనెక్షన్ విఫలమైంది",
  todoist_disconnect: "డిస్‌కనెక్ట్",
  todoist_disconnected: "Todoist డిస్‌కనెక్ట్ అయింది",
  todoist_disconnect_confirm: "Todoistను డిస్‌కనెక్ట్ చేయాలా? Todoistలో ఉన్న పనులు అలాగే ఉంటాయి. సింక్ ఆగుతుంది.",
  todoist_sync_now: "ఇప్పుడు సింక్ చేయండి",
  todoist_syncing: "సింక్ అవుతోంది…",
  todoist_sync_done: "సింక్ పూర్తయింది",
  todoist_sync_failed: "సింక్ విఫలమైంది",
  todoist_auth_error: "సింక్ కొనసాగించడానికి Todoistను మళ్లీ కనెక్ట్ చేయండి.",
  todoist_last_sync: "చివరి సింక్",
  todoist_not_connected: "Todoist కనెక్ట్ కాలేదు",
  todoist_auth_url_failed: "Todoist అనుమతి పేజీ తెరవలేకపోయింది.",
  recommend_text: "Kjuupలో చేరు, కనెక్ట్ అయి ఉండు, నీ కమ్యూనికేషన్‌ను క్రమబద్ధంగా ఉంచుకో. నీ ఛానెల్స్ అన్నింటినీ ఒకే చోటకు తీసుకురా, మెసేజ్‌లను సరైన ప్రాజెక్టుల్లో ఉంచు, ప్రతి ఉదయాన్ని ఒక సారాంశం, నీ పనులతో మొదలుపెట్టు – అన్నీ నువ్వు ఇప్పటికే వాడుతున్న యాప్స్‌తో సింక్ అవుతాయి. ఉచితంగా ప్రారంభించు:",
  pro_auth_signin_title: 'తిరిగి స్వాగతం',
  pro_auth_signin_sub: 'మీ పని ఇమెయిల్‌తో సైన్ ఇన్ చేయండి.',
  pro_auth_email_or_username: 'ఇమెయిల్ లేదా యూజర్‌నేమ్',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'పాస్‌వర్డ్ మర్చిపోయారా?',
  pro_auth_create_account: 'ఖాతా సృష్టించండి',
  pro_auth_show_password: 'పాస్‌వర్డ్ చూపు',
  pro_auth_hide_password: 'పాస్‌వర్డ్ దాచు',
  pro_auth_register_sub: 'మీ ఇమెయిల్‌ను నిర్ధారించడానికి మేము మీకు లింక్ పంపుతాము.',
  pro_auth_register_plus_sub: 'యూజర్‌నేమ్ మరియు పాస్‌వర్డ్ ఎంచుకోండి. తర్వాత మీ భద్రతా PIN సెట్ చేస్తారు.',
  pro_auth_check_credentials: 'మీ ఇమెయిల్ మరియు పాస్‌వర్డ్ తనిఖీ చేయండి',
  pro_news_export_pdf: 'PDF గా ఎగుమతి చేయి',
  pro_news_pdf_failed: 'PDF సృష్టించలేకపోయాము.',
  pro_news_pdf_attachments: 'జోడింపులు',
  pro_news_pdf_video: 'వీడియో',
  pro_auth_forgot_sub: 'మీ ఇమెయిల్ నమోదు చేయండి, పాస్‌వర్డ్ రీసెట్ చేయడానికి మేము లింక్ పంపుతాము.',
  pro_auth_send_link: 'రీసెట్ లింక్ పంపు',
  pro_auth_plus_reset: 'PIN తో రీసెట్ చేయి',
  pro_auth_show_pin: 'PIN చూపు',
  pro_auth_hide_pin: 'PIN దాచు',
  v2_auth_plus_only: 'Kjuup+ మాత్రమే',
  room_action_media: "ఫైళ్లు",
  room_tab_overview: "అవలోకనం",
  room_tab_history: "చరిత్ర",
  chat_info_media: "ఫైళ్లు",
  messages: "సందేశాలు",
  pro_todo_project_required: "దయచేసి ఒక ప్రాజెక్ట్‌ను ఎంచుకోండి",
  pro_todo_choose_project: "ఈ పని ఏ ప్రాజెక్ట్ కోసం?",
  cockpit_report_delete_confirm: "ఈ రోజువారీ నివేదికను తొలగించాలా?",
  cockpit_report_deleted: "రోజువారీ నివేదిక తొలగించబడింది",
  cockpit_tab_company: "కంపెనీ",
  cockpit_bookmarked_priorities: "బుక్‌మార్క్ చేసిన పనులు",
  cockpit_load_error: "కాక్‌పిట్‌ను లోడ్ చేయడం సాధ్యం కాలేదు.",
  cockpit_retry: "మళ్లీ ప్రయత్నించండి",
  cockpit_yesterday: "నిన్న",
  cockpit_greeting_morning: "శుభోదయం",
  cockpit_greeting_day: "శుభ మధ్యాహ్నం",
  cockpit_greeting_evening: "శుభ సాయంత్రం",
  cockpit_assistant_q_open: "ఈ రోజు ఏమి పెండింగ్‌లో ఉంది?",
  cockpit_assistant_q_summarize: "{{room}} చాట్‌ను సంగ్రహించండి",
  cockpit_assistant_q_overdue: "ఏ పనులు గడువు దాటాయి?",
  cockpit_assistant_new: "{{n}} కొత్తవి",
  cockpit_assistant_important: "{{n}} ముఖ్యమైనవి",
  cockpit_assistant_title: "Kjuup అసిస్టెంట్",
  cockpit_assistant_hint: "నొక్కి అడగండి",
  room_overview_priority_no_detail: "ఈ ప్రాధాన్యతపై నివేదికలో మరిన్ని వివరాలు లేవు.",
  room_overview_priority_from: "మూలం: {{name}}",
  room_overview_priority_open_task: "పనిని తెరవండి",
  cockpit_priority_position: "{{total}}లో {{index}} ప్రాధాన్యత",
  room_overview_today_title: "ఈరోజు ముఖ్యమైనవి",
  room_overview_all_tasks: "అన్నీ",
  room_overview_tasks_empty: "తెరిచిన గడువులు లేదా పనులు లేవు",
  room_overview_appointments_empty: "రాబోయే అపాయింట్‌మెంట్‌లు లేవు",
  room_overview_no_priorities: "తాజా నివేదికలో తెరిచి ఉన్న ప్రాధాన్యతలు లేవు.",
  cockpit_report_top5: "టాప్ 5 ప్రాధాన్యతలు",
  cockpit_report_todo_created: "పని సృష్టించబడింది",
  cockpit_report_source_missing: "మూల సందేశం కనుగొనబడలేదు.",
  delete_bookmarked_priority_confirm: "ఈ బుక్‌మార్క్ చేసిన పనిని తొలగించాలనుకుంటున్నారా?",
  cockpit_report_create_todo: "పనిని సృష్టించండి",
  cockpit_priorities_deleting: "తొలగిస్తోంది …",
  cockpit_priorities_select: "అనేకం తొలగించండి",
  cockpit_report_none: "ఎంట్రీలు లేవు.",
  cockpit_priorities_delete_confirm: "{count} బుక్‌మార్క్ చేసిన పనులను తొలగించాలనుకుంటున్నారా?",
  cockpit_priorities_delete_failed: "{count} పనులను తొలగించడం సాధ్యం కాలేదు",
  cockpit_priorities_deleted: "{count} పనులు తొలగించబడ్డాయి",
  cockpit_priorities_selected: "{count} ఎంచుకున్నారు",
  cockpit_channel_connected: "కనెక్ట్ అయింది",
  cockpit_channel_not_connected: "కనెక్ట్ కాలేదు",
  cockpit_channel_connect: "కనెక్ట్ చేయండి",
  cockpit_channel_chat: "Kjuup చాట్",
  cockpit_channel_active: "యాక్టివ్",
  cockpit_channel_hidden: "దాచబడింది",
  cockpit_channel_enable: "ప్రారంభించండి",
  cockpit_channel_email: "ఇమెయిల్",
  cockpit_channel_check: "కనెక్షన్‌ను తనిఖీ చేయండి",
  cockpit_channel_fix: "తనిఖీ చేయండి",
  cockpit_channel_forward: "ఫార్వార్డింగ్ చిరునామా",
  cockpit_channel_not_set_up: "సెటప్ చేయలేదు",
  cockpit_channel_set_up: "సెటప్ చేయండి",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "కనెక్షన్ తెగిపోయింది",
  cockpit_channel_importing: "దిగుమతి చేస్తోంది",
  cockpit_channel_removing: "డిస్‌కనెక్ట్ చేస్తోంది",
  cockpit_channel_reconnect: "మళ్లీ కనెక్ట్ చేయండి",
  cockpit_channels_title: "ఛానెల్స్",
  cockpit_company_role_super_admin: "కంపెనీ అడ్మిన్",
  cockpit_company_role_dept_admin: "విభాగ అడ్మిన్",
  cockpit_company_role_member: "ఉద్యోగి",
  cockpit_company_none: "Kjuup+ కంపెనీ కనుగొనబడలేదు",
  cockpit_company_eyebrow: "కంపెనీ",
  cockpit_company_inactive: "నిష్క్రియం",
  cockpit_company_settings: "కంపెనీ సెట్టింగ్‌లు",
  cockpit_company_employees: "ఉద్యోగులు",
  cockpit_company_internal_rooms: "అంతర్గత ప్రాజెక్టులు",
  cockpit_report_all_projects: "అన్ని ప్రాజెక్టులు",
  cockpit_report_progress_emails: "ఇమెయిళ్లను విశ్లేషిస్తోంది",
  cockpit_report_progress_chats: "చాట్ సందేశాలను విశ్లేషిస్తోంది",
  cockpit_report_progress_documents: "అటాచ్‌మెంట్లు మరియు పత్రాలను విశ్లేషిస్తోంది",
  cockpit_report_progress_tasks: "పనులను విశ్లేషిస్తోంది",
  cockpit_report_progress_summarizing: "కంటెంట్‌ను విశ్లేషిస్తోంది",
  cockpit_report_progress_reading: "ఇప్పటికే విశ్లేషించిన కంటెంట్‌ను మళ్లీ ఉపయోగిస్తోంది",
  cockpit_report_progress_collecting: "మీ ప్రాజెక్టుల నుండి ఇమెయిళ్లు, చాట్‌లు మరియు పనులను సేకరిస్తోంది",
  cockpit_report_progress_priorities: "ప్రాధాన్యతలు, గడువులు మరియు నిర్ణయాలను సంకలనం చేస్తోంది",
  cockpit_report_progress_queued: "నివేదికను సిద్ధం చేస్తోంది",
  cockpit_report_creating_title: "మీ రోజువారీ నివేదిక సిద్ధమవుతోంది",
  cockpit_report_progress_count_one: "1 అంశం విశ్లేషించబడింది",
  cockpit_report_progress_count_many: "{{count}} అంశాలు విశ్లేషించబడ్డాయి",
  cockpit_report_progress_hint: "దీనికి సాధారణంగా ఒకటి నుండి రెండు నిమిషాలు పడుతుంది – ఈలోగా మీరు కాక్‌పిట్‌ను ఉపయోగించవచ్చు.",
  cockpit_report_time_hint: "అత్యంత చురుకైన ఐదు ప్రాజెక్టుల కోసం రోజువారీ నివేదిక ప్రతిరోజూ {{hour}}:00 గంటలకు సృష్టించబడుతుంది.",
  room_overview_priorities_title: "ప్రస్తుత స్థితి మరియు ప్రాధాన్యతలు",
  room_overview_as_of: "{{time}} నాటికి",
  cockpit_report_delete: "రోజువారీ నివేదికను తొలగించండి",
  email_tag_daily_briefing: "రోజువారీ నివేదిక",
  cockpit_report_unread: "కొత్తది",
  cockpit_report_clear_project: "అన్ని ప్రాజెక్టులను చూపించండి",
  cockpit_filter_project: "ప్రాజెక్ట్",
  cockpit_filter_all_projects: "అన్ని ప్రాజెక్టులు",
  cockpit_report_recreate: "రోజువారీ నివేదికను మళ్లీ సృష్టించండి",
  cockpit_report_hide_previous: "మునుపటి రోజువారీ నివేదికలను దాచండి",
  cockpit_report_show_previous: "మునుపటి రోజువారీ నివేదికలను చూపించండి",
  cockpit_report_room_empty: "ఈ ప్రాజెక్ట్‌కు ఇంకా రోజువారీ నివేదిక లేదు",
  cockpit_report_empty: "ఇంకా రోజువారీ నివేదిక లేదు",
  cockpit_report_room_empty_hint: "ఈ ప్రాజెక్ట్ కోసం మాత్రమే రోజువారీ నివేదికను సృష్టించండి.",
  cockpit_report_needs_mailbox: "ఆటోమేటిక్ పనులతో Kjuup రోజువారీ నివేదికను సృష్టించగలిగేలా ఇమెయిల్ ఖాతాను కనెక్ట్ చేయండి.",
  cockpit_report_create: "రోజువారీ నివేదికను సృష్టించండి",
  cockpit_email_connect: "ఇమెయిల్‌ను కనెక్ట్ చేయండి",
  cockpit_email_none_title: "ఇంకా ఇమెయిల్ ఖాతా కనెక్ట్ చేయబడలేదు",
  cockpit_email_none_reports: "Kjuup వచ్చే ఇమెయిళ్లను మీ ప్రాజెక్టులకు కేటాయించి, పనులతో రోజువారీ నివేదికలను సృష్టించగలిగేలా మీ మెయిల్‌బాక్స్‌ను కనెక్ట్ చేయండి.",
  cockpit_email_none_client: "Kjuup.io లోనే ఇమెయిళ్లను చదవడానికి, కేటాయించడానికి మరియు సమాధానం ఇవ్వడానికి Gmail, Outlook లేదా IMAPను కనెక్ట్ చేయండి.",
  cockpit_email_reports_title: "ప్రస్తుత ఇమెయిల్ క్లయింట్",
  cockpit_email_reports_text: "Kjuup.io లో ఇన్‌బాక్స్ లేదు · ప్రతిరోజూ {{hour}}:00 గంటలకు రోజువారీ నివేదికతో {{rooms}} ప్రాజెక్టులు · వచ్చే ఇమెయిళ్లు మీ ప్రాజెక్టులకు కేటాయించబడతాయి.",
  cockpit_email_reports_rooms: "ప్రాజెక్టులను నిర్వహించండి",
  cockpit_email_settings: "ఇమెయిల్ సెట్టింగ్‌లు",
  cockpit_email_error_title: "కనెక్షన్‌ను తనిఖీ చేయండి",
  cockpit_email_client_title: "ఇన్‌బాక్స్ కనెక్ట్ అయింది",
  cockpit_email_accounts_n: "{{n}} ఖాతా కనెక్ట్ చేయబడింది",
  cockpit_email_last_sync: "చివరి సింక్ {{when}}",
  cockpit_email_report_at: "{{hour}}:00 గంటలకు రోజువారీ నివేదిక",
  cockpit_email_open_inbox: "ఇన్‌బాక్స్ తెరవండి",
  cockpit_email_eyebrow: "Kjuup-ఇమెయిల్",
  cockpit_email_accounts_label: "కనెక్ట్ చేసిన ఇమెయిల్ చిరునామాలు",
  email_folder_sent: "పంపిన అంశాలు",
  email_no_subject: "(విషయం లేదు)",
  cockpit_email_detail_loading: "ఇమెయిల్ లోడ్ అవుతోంది …",
  cockpit_email_detail_failed: "ఇమెయిల్‌ను లోడ్ చేయడం సాధ్యం కాలేదు.",
  cockpit_email_detail_empty: "ఈ ఇమెయిల్‌లో టెక్స్ట్ లేదు.",
  cockpit_personal_settings: "వ్యక్తిగత సెట్టింగ్‌లు",
  cockpit_companies: "కంపెనీలు",
  cockpit_title: "కాక్‌పిట్",
  cockpit_back: "అవలోకనానికి తిరిగి",
  cockpit_day_overview: "ఒక్క చూపులో మీ రోజు",
  email_saved_to_project: "ఇమెయిల్ ప్రాజెక్ట్‌లో సేవ్ చేయబడింది",
  email_classify_need_project: "దయచేసి ప్రాజెక్ట్ పేరును నమోదు చేయండి",
  cockpit_email_deleted: "ఇమెయిల్ తొలగించబడింది",
  cockpit_email_sent_empty: "ఇంకా పంపిన ఇమెయిళ్లు లేవు.",
  cockpit_email_incoming_empty: "ఇంకా వచ్చిన ఇమెయిళ్లు లేవు.",
  cockpit_email_incoming_title: "ఇమెయిళ్లు",
  cockpit_email_incoming_sub: "వచ్చిన మరియు పంపిన ఇమెయిళ్లను మీ ప్రాజెక్టులకు కేటాయించండి. కేటాయింపును ఇక్కడ సర్దుబాటు చేయవచ్చు.",
  cockpit_email_incoming_unassigned_n: "{{n}} కేటాయించలేదు",
  cockpit_email_folder_inbox: "ఇన్‌బాక్స్",
  cockpit_email_folder_sent: "పంపినవి",
  cockpit_email_open: "ఇమెయిల్ తెరవండి",
  cockpit_email_incoming_suggested: "సూచన: {{room}}",
  cockpit_email_incoming_apply: "వర్తింపజేయండి",
  cockpit_email_incoming_adjust: "కేటాయింపును మార్చండి",
  cockpit_email_incoming_saving: "సేవ్ చేస్తోంది …",
  cockpit_email_incoming_unassigned: "కేటాయించలేదు",
  cockpit_email_incoming_show_less: "తక్కువ చూపించండి",
  cockpit_email_incoming_show_all: "మొత్తం {{n}} చూపించండి",
  cockpit_io_settings: "Kjuup.io సెట్టింగ్‌లు",
  cockpit_io_settings_sub: "ప్లాన్ మరియు సీట్లు, ఉద్యోగుల కేటాయింపు, బిల్లింగ్ మరియు ఇన్‌వాయిస్‌లు.",
  products_coming_soon: "త్వరలో వస్తోంది",
  cockpit_upsell_io_title: "మీతో కలిసి ఆలోచించే మీ కార్యాలయం",
  cockpit_upsell_io_text: "మీ ఇమెయిల్ ఖాతాలను Kjuup తో కనెక్ట్ చేయండి. ఇమెయిళ్లు, అటాచ్‌మెంట్లు మరియు సందేశాలు సరైన ప్రాజెక్ట్‌లో ఆటోమేటిక్‌గా సేవ్ అవుతాయి మరియు కావాలంటే మీ సర్వర్‌లో నిల్వ చేయవచ్చు. ప్రతిరోజూ అన్ని ప్రాజెక్టుల సారాంశం మరియు అన్ని కంటెంట్ నుండి ముఖ్యాంశాలు మీకు అందుతాయి, మీ పనులు మీ క్యాలెండర్ లేదా to-do యాప్‌తో సింక్ అవుతాయి.",
  cockpit_upsell_io_soon_title: "ఇంకా బుక్ చేయడం సాధ్యం కాదు",
  cockpit_upsell_io_soon_text: "Kjuup.io త్వరలో ప్రారంభమవుతోంది. ఇప్పుడే సమాచారం అభ్యర్థించండి – Kjuup.io బుక్ చేయడం సాధ్యమైన వెంటనే మీకు తెలియజేస్తాము.",
  cockpit_upsell_io_planned_price: "ప్రణాళిక ధర",
  cockpit_upsell_io_cta_request: "సమాచారం అభ్యర్థించండి",
  kjuup_plus_abo_per_year: "/ సంవత్సరం",
  kjuup_plus_abo_per_month: "/ నెల",
  kjuup_plus_abo_status_active: "యాక్టివ్",
  kjuup_plus_abo_status_requested: "రద్దు అభ్యర్థించబడింది",
  kjuup_plus_abo_status_past_due: "చెల్లింపు బకాయి",
  kjuup_plus_abo_eyebrow: "Kjuup+ · సబ్‌స్క్రిప్షన్",
  kjuup_plus_abo_title: "Kjuup+ ప్యాకేజీ",
  kjuup_plus_abo_seats_free_one: "1 సీటు మిగిలి ఉంది",
  kjuup_plus_abo_billing: "బిల్లింగ్",
  kjuup_plus_abo_yearly: "వార్షికం",
  kjuup_plus_abo_monthly: "నెలవారీ",
  kjuup_plus_abo_amount: "మొత్తం",
  kjuup_plus_abo_ends: "ముగింపు తేదీ",
  kjuup_plus_abo_renews: "తదుపరి పునరుద్ధరణ",
  kjuup_plus_abo_next_invoice: "తదుపరి ఇన్‌వాయిస్",
  kjuup_plus_abo_intro: "పరిచయ ధర",
  kjuup_plus_abo_pending_tier: "తదుపరి పునరుద్ధరణ నుండి",
  kjuup_plus_abo_manual: "Kjuup+ మీ కంపెనీకి వ్యక్తిగత ఒప్పందం ప్రకారం యాక్టివ్‌గా ఉంది.",
  kjuup_plus_abo_invoices: "ఇన్‌వాయిస్‌లు",
  kjuup_plus_abo_invoice_paid: "చెల్లించబడింది",
  kjuup_plus_abo_invoice_view: "చూడండి",
  kjuup_plus_abo_invoices_less: "తక్కువ చూపించండి",
  kjuup_plus_abo_member_hint: "బిల్లింగ్ మరియు రద్దును మీ కంపెనీ అడ్మిన్‌లు నిర్వహిస్తారు.",
  kjuup_plus_abo_withdraw: "అభ్యర్థనను ఉపసంహరించండి",
  kjuup_plus_abo_cancel_note: "కారణం (ఐచ్ఛికం)",
  kjuup_plus_abo_cancel_send: "రద్దును అభ్యర్థించండి",
  kjuup_plus_abo_cancel: "సబ్‌స్క్రిప్షన్‌ను రద్దు చేయండి",
  cockpit_upsell_plus_f1: "మీ ఉద్యోగులందరి కమ్యూనికేషన్ కార్యకలాపాలను నిర్వహించండి",
  cockpit_upsell_plus_f2: "కంపెనీలోని నిర్దిష్ట వినియోగదారు సమూహాలకు తెలియజేయండి",
  cockpit_upsell_plus_f3: "అంతర్గత గ్రూప్ చాట్‌లను సేవ్ చేయండి",
  cockpit_upsell_plus_when_yearly: "వార్షికంగా చెల్లిస్తే",
  cockpit_upsell_plus_size_small: "1–50 ఉద్యోగులు",
  cockpit_upsell_plus_size_large: "51–200 ఉద్యోగులు",
  cockpit_upsell_plus_title: "కంపెనీల కోసం Kjuup+",
  cockpit_upsell_plus_text: "ఉద్యోగులను, రాసే అనుమతులను మరియు కంపెనీ కమ్యూనికేషన్‌ను ఒకే చోట నిర్వహించండి. అంతర్గత ఛానెల్స్ మీ బృందంలోనే ఉంటాయి, బాహ్య ఛానెల్స్ మిమ్మల్ని ప్రాజెక్ట్ భాగస్వాములతో కలుపుతాయి మరియు మీరు నిర్దిష్ట సమూహాలను నేరుగా చేరుకోవచ్చు. Kjuup+ తో పాటు, ఉద్యోగుల సమూహాల కోసం Kjuup.io యాక్సెస్‌ను బుక్ చేయవచ్చు. Kjuup+ మరియు Kjuup.io ను కలిపి ఉపయోగించవచ్చు.",
  cockpit_upsell_plus_size: "కంపెనీ పరిమాణం",
  cockpit_upsell_plus_billing: "బిల్లింగ్",
  cockpit_upsell_plus_per_company: "/ కంపెనీ · నెలకు, VAT మినహా",
  cockpit_upsell_plus_onboarding: "ఆన్‌బోర్డింగ్/పరిచయ ఖర్చులు కంపెనీ పరిమాణంపై ఆధారపడి ఉంటాయి",
  cockpit_upsell_plus_larger: "పెద్ద కంపెనీల ధరలు అభ్యర్థనపై",
  cockpit_upsell_plus_cta: "బాధ్యత లేకుండా విచారించండి",
  cockpit_kpi_deadlines_tasks: "గడువులు & పనులు",
  cockpit_kpi_appointments: "అపాయింట్‌మెంట్లు",
  cockpit_room_admin: "ప్రాజెక్ట్ & చాట్ నిర్వహణ",
  cockpit_room_admin_sub: "సభ్యులు, మీడియా మరియు చాట్‌లతో కంపెనీ ప్రాజెక్టులన్నీ.",
  pro_todo_not_found: "ఈ పని ఇకపై అందుబాటులో లేదు.",
  cockpit_chip_overdue: "గడువు దాటింది",
  cockpit_chip_today: "ఈ రోజు",
  cockpit_calendar_week: "వారం {{week}}",
  cockpit_prev_week: "మునుపటి వారం",
  cockpit_next_week: "తదుపరి వారం",
  cockpit_chip_requested: "అభ్యర్థించబడింది",
  cockpit_todo_due: "గడువు {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} నుండి",
  cockpit_todo_since: "{{when}} నుండి",
  cockpit_todo_no_date: "తేదీ లేదు",
  cockpit_todo_mark_done: "పూర్తయినట్లు గుర్తించండి",
  cockpit_my_tasks_title: "నా పనులు",
  cockpit_today_tasks_group: "ఈ రోజు పనులు",
  cockpit_assign_none: "ఎవరికీ కేటాయించలేదు",
  no_project_found: "ప్రాజెక్ట్ కనుగొనబడలేదు",
  cockpit_row_more_actions: "మరిన్ని చర్యలు",
  needs_date: "తేదీని కేటాయించండి",
  cockpit_assign_proposal: "{{name}} గుర్తించబడింది – కేటాయించాలా?",
  cockpit_assign_proposal_confirm: "కేటాయించండి",
  cockpit_assign_proposal_dismiss: "విస్మరించండి",
  cockpit_priority_date: "తేదీ",
  todo_calendar_add: "క్యాలెండర్‌కు జోడించండి",
  todo_calendar_remove: "క్యాలెండర్ నుండి తొలగించండి",
  cockpit_todo_change_project: "ప్రాజెక్ట్ మార్చండి",
  cockpit_todo_set_date: "తేదీని సెట్ చేయండి",
  pro_todo_done_confirm: "ఈ పనిని నిజంగా పూర్తయినట్లు గుర్తించాలనుకుంటున్నారా?",
  cockpit_task_delete_failed: "పనిని తొలగించడం సాధ్యం కాలేదు.",
  cockpit_setup_title: "సెటప్ పూర్తి చేయండి",
  cockpit_setup_text: "మీరు చాట్‌లను ఉపయోగించాలనుకుంటున్నారా మరియు Kjuup.io ఇమెయిల్ క్లయింట్‌గా పని చేయాలా లేక ప్రాజెక్టులు మరియు రోజువారీ నివేదికలతో మాత్రమే పని చేయాలా అని నిర్ణయించండి.",
  cockpit_setup_cta: "ఇప్పుడే సెటప్ చేయండి",
  cockpit_group_tasks: "గడువులు & పనులు",
  cockpit_group_appointments: "అపాయింట్‌మెంట్లు",
  cockpit_report_no_activity: "గత 24 గంటల్లో ఈ ప్రాజెక్ట్‌లో కొత్త సందేశాలు లేదా ఇమెయిళ్లు లేవు.",
  cockpit_report_room_unavailable: "ఈ ప్రాజెక్ట్ అందుబాటులో లేదు.",
  cockpit_report_create_failed: "రోజువారీ నివేదికను సృష్టించడం సాధ్యం కాలేదు.",
  cockpit_report_created: "రోజువారీ నివేదిక సృష్టించబడింది",
  addon_enable_confirm: "యాడ్-ఆన్‌ను ప్రారంభించాలా?",
  addon_enable: "ప్రారంభించండి",
  addon_enabled: "యాడ్-ఆన్ ప్రారంభించబడింది",
  nav_email: "ఇమెయిల్",
  nav_my_cockpit: "నా కాక్‌పిట్",
  nav_news: "వార్తలు",
  nav_recommend: "సిఫార్సు చేయండి",
  pro_todo_status_done: "పూర్తయింది",
  pro_todo_status_open: "తెరిచి ఉంది",
  v2_todo_remove: "తొలగించండి",
  pro_todo_search_people: "వ్యక్తులను శోధించండి",
  pro_todo_clear: "క్లియర్ చేయండి",
  pro_todo_assigned: "(కేటాయించబడింది)",
  pro_todo_no_people: "వ్యక్తులు ఎవరూ కనుగొనబడలేదు",
  pro_todo_search_rooms: "ప్రాజెక్టులను శోధించండి",
  pro_todo_no_rooms_match: "“{{q}}”కు సరిపోలే ప్రాజెక్టులు లేవు",
  pro_todo_no_rooms: "ప్రాజెక్టులు కనుగొనబడలేదు",
  pro_todo_activity: "కార్యకలాపం",
  pro_todo_show_less: "తక్కువ చూపించండి",
  pro_todo_show_all: "అన్నీ చూపించండి ({{n}})",
  pro_todo_due: "గడువు",
  pro_todo_room: "ప్రాజెక్ట్",
  pro_todo_select_room: "ప్రాజెక్ట్‌ను ఎంచుకోండి",
  pro_todo_status: "స్థితి",
  pro_todo_more: "మరిన్ని",
  pro_todo_edit_title: "పనిని సవరించండి",
  pro_todo_description: "వివరణ",
  pro_todo_created_by: "సృష్టించినవారు",
  pro_todo_chat: "చాట్",
  navigate_to_source: "మూలానికి వెళ్లండి",
  todo_calendar_connect_title: "క్యాలెండర్ కనెక్ట్ చేయలేదు",
  todo_calendar_connect_body_web: "ToDoలను జోడించడానికి క్యాలెండర్ సింక్ సెట్టింగ్‌లలో క్యాలెండర్‌ను కనెక్ట్ చేయండి.",
  todo_calendar_connect: "కనెక్ట్ చేయండి",
  todo_calendar_removed: "మీ క్యాలెండర్ నుండి తొలగించబడింది",
  todo_calendar_added_later: "జోడించబడింది. మీ క్యాలెండర్‌ను చేరుకోలేకపోయాము; Kjuup తర్వాత మళ్లీ ప్రయత్నిస్తుంది.",
  todo_calendar_added: "మీ క్యాలెండర్‌కు జోడించబడింది",
  todo_calendar_no_date: "తేదీ ఉన్న ToDoను మాత్రమే క్యాలెండర్‌కు జోడించవచ్చు.",
  todo_calendar_failed: "మీ క్యాలెండర్‌ను అప్‌డేట్ చేయడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
  todo_calendar_date_title: "ఇంకా తేదీ లేదు",
  todo_calendar_date_save: "తేదీని సెట్ చేసి జోడించండి",
  todo_calendar_date_body_web: "ఈ బుక్‌మార్క్ చేసిన పనికి ఇంకా తేదీ లేదు. మీ క్యాలెండర్‌కు జోడించడానికి తేదీని సెట్ చేయండి.",
  kjuup_io_setup_saved: "సెటప్ సేవ్ చేయబడింది",
  kjuup_io_setup_step: "దశ",
  kjuup_io_setup_chats_title: "మీరు చాట్‌లను ఉపయోగించాలనుకుంటున్నారా?",
  kjuup_io_setup_email_title: "మీరు మీ ఇమెయిళ్లను ఎక్కడ చదవాలనుకుంటున్నారు?",
  kjuup_io_setup_chats_sub: "సహోద్యోగులు మరియు ప్రాజెక్ట్ భాగస్వాములతో చాట్‌లు ఐచ్ఛికం. మీరు వాటిని కాక్‌పిట్‌లో ఎప్పుడైనా చూపవచ్చు లేదా దాచవచ్చు.",
  kjuup_io_setup_email_sub: "మీరు Kjuup లో ఇమెయిల్ క్లయింట్‌ను ఉపయోగిస్తారా లేదా Outlook వంటి మీ ప్రస్తుత ఇమెయిల్ ప్రోగ్రామ్‌నే కొనసాగిస్తారా అనేది మాత్రమే ఇది నిర్ణయిస్తుంది. మీరు తర్వాత మార్చవచ్చు.",
  kjuup_io_setup_chats_yes: "అవును, చాట్‌లను చూపించండి",
  kjuup_io_setup_chats_yes_text: "సందేశాల్లో చాట్‌లు మరియు ఇమెయిళ్లు ఉంటాయి. ప్రాజెక్టులలో పాల్గొనే అందరికీ గ్రూప్ చాట్‌లు ఉంటాయి.",
  kjuup_io_setup_chats_no: "లేదు, చాట్‌లు లేకుండా పని చేయండి",
  kjuup_io_setup_chats_no_text: "చాట్‌లు దాచబడతాయి. \"సందేశాలు\" \"ఇమెయిల్\"గా మారుతుంది; ప్రాజెక్టులు, పనులు మరియు రోజువారీ నివేదికలు అలాగే ఉంటాయి.",
  kjuup_io_setup_email_client: "Kjuup లో ఇమెయిల్ క్లయింట్",
  kjuup_io_setup_email_client_text: "ఇమెయిళ్లను నేరుగా Kjuup లో చదివి సమాధానం ఇవ్వండి.",
  kjuup_io_setup_email_reports: "ప్రస్తుత ఇమెయిల్ క్లయింట్",
  kjuup_io_setup_email_reports_text: "Outlook లేదా మరొకటి వంటి మీ ప్రస్తుత ప్రోగ్రామ్‌లోనే చదవడం మరియు సమాధానం ఇవ్వడం కొనసాగించండి.",
  kjuup_io_setup_skip: "తర్వాత",
  next: "తదుపరి",
  kjuup_io_setup_finish: "సెటప్ పూర్తి చేయండి",
  today_label: "ఈ రోజు",
  tomorrow_label: "రేపు",
  cockpit_todo_overdue: "గడువు దాటింది",
  cockpit_report_management_fazit: "నిర్వహణ సారాంశం",
  cockpit_todo_appointment: "అపాయింట్‌మెంట్",
  cockpit_todo_deadline: "గడువు",
  cockpit_todo_deadline_define: "గడువును నిర్వచించండి",
  pro_todo_status_acknowledged: "నిర్ధారించబడింది",
  pro_todo_responsible: "బాధ్యులు",
  pro_todo_notice_confirmed: "చాట్‌లో నిర్ధారించబడింది",
  pro_todo_notice_sent_at: "సందేశం పంపబడింది",
  pro_todo_notice_again: "సందేశాన్ని మళ్లీ పంపండి",
  pro_todo_notice_send: "Kjuup సందేశం ద్వారా తెలియజేయండి",
  pro_todo_add_assignee: "జోడించండి",
  pro_todo_edit: "సవరించండి",
  pro_todo_change_room: "ప్రాజెక్ట్ మార్చండి",
  pro_todo_due_on: "గడువు తేదీ",
  pro_todo_edit_due: "గడువును సవరించండి",
  pro_todo_no_date: "తేదీ లేదు",
  pro_todo_edit_description: "వివరణను సవరించండి",
  pro_todo_no_description: "ఇంకా వివరణ లేదు",
  pro_todo_title_label: "శీర్షిక",
  pro_todo_title_placeholder: "శీర్షికను నమోదు చేయండి...",
  pro_todo_task: "పని",
  pro_todo_what: "ఏమి చేయాలి?",
  pro_todo_source_email: "ఇమెయిల్",
  pro_todo_sources: "మూలాలు",
  previous: "మునుపటిది",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} మంది ఉద్యోగుల వరకు)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} మంది ఉద్యోగుల వరకు)",
  kjuup_plus_abo_status_ends: "{date}న ముగుస్తుంది",
  kjuup_plus_abo_seats_over: "{max} మంది కంటే ఎక్కువ ఉద్యోగులు – Kjuup ప్రత్యేక ఆఫర్‌తో మిమ్మల్ని సంప్రదిస్తుంది.",
  kjuup_plus_abo_seats_next: "మరిన్ని ఉద్యోగులు చేరితే, ప్యాకేజీ స్వయంచాలకంగా {next}కి మారుతుంది (దామాషా ప్రకారం).",
  kjuup_plus_abo_seats_used: "{total} సీట్లలో {used} ఉపయోగంలో ఉన్నాయి",
  kjuup_plus_abo_seats_free: "{count} సీట్లు మిగిలి ఉన్నాయి",
  kjuup_plus_abo_intro_until: "{date} వరకు",
  kjuup_plus_abo_invoice_open: "బకాయి · గడువు {date}",
  kjuup_plus_abo_invoices_all: "మొత్తం {count} చూపించండి",
  kjuup_plus_abo_requested_hint: "{date}న రద్దు అభ్యర్థించబడింది. వ్యవధి ముగింపులో ({end}) Kjuup దీన్ని నిర్ధారిస్తుంది.",
  kjuup_plus_abo_cancel_hint: "Kjuup మీ అభ్యర్థనను సమీక్షించి, వ్యవధి ముగింపులో ({end}) రద్దును నిర్ధారిస్తుంది. అప్పటివరకు Kjuup+ యాక్టివ్‌గా ఉంటుంది.",
  kjuup_plus_abo_withdrawn: "రద్దు అభ్యర్థన ఉపసంహరించబడింది",
  kjuup_plus_abo_requested: "రద్దు అభ్యర్థించబడింది",
  cockpit_upsell_plus_intro_hint: "మొదటి {months} నెలలు, తర్వాత {price}",
  cockpit_upsell_plus_badge: "{months} నెలల పరిచయ ధర",
  calendar_syncing: "క్యాలెండర్ నుండి నవీకరిస్తోంది…",
  calendar_sync_up_to_date: "క్యాలెండర్ తాజాగా ఉంది",
  calendar_sync_failed: "సింక్ విఫలమైంది",
  delete_multiple_tasks_confirm: "మీరు నిజంగా {count} ToDoలను తొలగించాలనుకుంటున్నారా?",
  todos_deleted_count: "{count} ToDoలు తొలగించబడ్డాయి",
  todos_deleted_partial: "{ok} ToDoలు తొలగించబడ్డాయి, {fail} విఫలమయ్యాయి",
  todo_unknown: "తెలియని",
  todo_created_from_message: "ఈ సందేశం నుండి పని సృష్టించబడింది",
  kjuup_io_todo_calendar_trial_ended_note: "క్యాలెండర్ సింక్ · సబ్‌స్క్రైబ్ చేయండి",
  kjuup_io_todo_calendar_nudge: "ఈ ToDoను మీ క్యాలెండర్‌కు సింక్ చేయాలా?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io యాక్టివేట్ చేయండి",
  todo_confirmed: "ToDo నిర్ధారించబడింది",
  pro_todo_bulk_delete_title: "{{n}} పనులను తొలగించాలా?",
  pro_todo_previous_none_own: "గడువు దాటిన పనులు ఇతరులు మీకు కేటాయించినవి, వాటిని వారు మాత్రమే తొలగించగలరు.",
  pro_todo_previous_none: "గడువు దాటిన పనులు లేవు",
  pro_todo_previous_title: "గడువు దాటిన {{n}} పనులను తొలగించాలా?",
  pro_todo_previous_text: "గత రోజుల్లోని మీ తెరిచి ఉన్న పనులన్నీ తొలగించబడతాయి.",
  pro_todo_previous_skipped: "ఇతరులు కేటాయించిన {{n}} పనులు అలాగే ఉంటాయి.",
  unassign_task_confirm: "ఈ టాస్క్ నుండి మీ కేటాయింపును రద్దు చేయాలనుకుంటున్నారా?",
  unassign_label: "రద్దు చేయి",
  pro_todo_delete_title: "పనిని తొలగించండి",
  pro_todo_today: "ఈరోజు",
  pro_todo_yesterday: "నిన్న",
  pro_todo_since_yesterday: "నిన్నటి నుండి",
  pro_todo_mark_open: "తెరిచి ఉన్నట్లు గుర్తించండి",
  verify_completion: "నిర్ధారించు",
  new_label: "కొత్తది",
  bookmarked_no_mylist: "బుక్‌మార్క్ చేసిన టాస్క్‌లను నా జాబితాకు జోడించలేరు",
  delete_only_own: "మీరు సృష్టించిన పనులను మాత్రమే తొలగించగలరు",
  todo_clear_all: "అన్నీ తొలగించు",
  pro_todo_of_completed: "{{total}}లో {{done}} పూర్తయ్యాయి",
  pro_todo_pick_date: "తేదీ ఎంచుకోండి",
  pro_todo_show_day: "రోజు చూపు",
  todo_adjust_list: "జాబితాను సర్దుబాటు చేయండి",
  pro_todo_section_upcoming: "రాబోయేవి",
  pro_todo_section_done: "పూర్తయినవి",
  pro_todo_room_empty_today: "ఈ ప్రాజెక్ట్‌లో ఈరోజు పనులు లేవు",
  pro_todo_room_empty_day: "ఈ ప్రాజెక్ట్‌లో ఈ రోజున పనులు లేవు",
  pro_todo_delete_previous: "అన్నీ తొలగించండి",
  todo_my_list_empty: "మీ రోజు ఖాళీగా ఉంది",
  todo_my_list_empty_hint: "పనులను జోడించడానికి “జాబితాను సర్దుబాటు చేయండి”పై క్లిక్ చేయండి",
  pro_todo_empty_title: "ఇక్కడ ఏమీ లేదు",
  pro_todo_empty_hint: "ఈ వీక్షణకు సరిపోయే టాస్క్‌లు లేవు.",
  pro_todo_selected: "{{n}} ఎంచుకోబడ్డాయి",
  delete_selected_count: "తొలగించు ({count})",
  pro_todo_adjust_done: "పూర్తయింది",
  pro_todo_deleting: "తొలగిస్తోంది...",
  pro_todo_reopen: "టాస్క్ మళ్లీ తెరువు",
  pro_todo_step_done: "పూర్తయింది",
  move_back_in_progress: "తిరిగి జరుగుతోంది స్థితికి మార్చు",
  pro_todo_mark_not_started: "ప్రారంభించలేదని గుర్తించు",
  back_into_in_progress: "తిరిగి ప్రగతిలోకి",
  pro_todo_mark_in_progress: "ప్రగతిలో ఉందని గుర్తించు",
  unassign_todo: "ToDo కేటాయింపును రద్దు చేయి",
  pro_todo_open_room: "ప్రాజెక్ట్ తెరువు",
  pro_todo_new_task: "కొత్త టాస్క్",
  select_user_back_to_in_progress: "తిరిగి జరుగుతోంది స్థితికి మార్చడానికి వినియోగదారుని ఎంచుకోండి",
  cockpit_email_accounts_n_many: "{{n}} ఖాతాలు కనెక్ట్ చేయబడ్డాయి",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup పరిచయాలు",
  combined_tab_teams: "Teams పరిచయాలు",
  combined_bridge_failed: "Teams కాపీని సృష్టించడం సాధ్యం కాలేదు.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup మరియు Teams పరిచయాలు: Microsoft Teamsలో కూడా కనిపించే కొత్త సమూహం సృష్టించబడుతుంది.",
  teams_new_chat_title: "కొత్త Teams చాట్",
  teams_new_chat_topic: "సమూహం పేరు (ఐచ్ఛికం)",
  teams_new_chat_start: "చాట్ ప్రారంభించండి",
  teams_new_chat_creating: "చాట్ సృష్టించబడుతోంది…",
  teams_new_chat_forbidden: "Microsoft Teams ఈ చాట్‌ను అనుమతించదు (ఉదా. మీ సంస్థ వెలుపలి వ్యక్తి లేదా మీ IT విధానం).",
  teams_new_chat_too_many: "ఒక చాట్‌కు చాలా ఎక్కువ మంది.",
  teams_new_chat_type_hint: "మీ సంస్థలో వెతకడానికి పేరు టైప్ చేయండి.",
  teams_new_chat_directory_forbidden: "మీ సంస్థ డైరెక్టరీ శోధనను అనుమతించదు. మీ Teams చాట్‌లలోని వ్యక్తులు మాత్రమే చూపబడతారు.",
  teams_new_chat_account: "ఖాతా",
};
